/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccountDto } from '../models';
// @ts-ignore
import type { AccountResultDto } from '../models';
// @ts-ignore
import type { AccountV3Response } from '../models';
// @ts-ignore
import type { AccountXYear } from '../models';
// @ts-ignore
import type { ActivationGuideDto } from '../models';
// @ts-ignore
import type { ActivationGuidePatchDto } from '../models';
// @ts-ignore
import type { ActiveSessionsResponseDto } from '../models';
// @ts-ignore
import type { AddBankDataRequestDto } from '../models';
// @ts-ignore
import type { AgreementStatus } from '../models';
// @ts-ignore
import type { AlarmItemDto } from '../models';
// @ts-ignore
import type { AlarmWithLogDto } from '../models';
// @ts-ignore
import type { AmlCheckResolutionRequest } from '../models';
// @ts-ignore
import type { AttestStatus } from '../models';
// @ts-ignore
import type { AuditLogDto } from '../models';
// @ts-ignore
import type { AuthPersonInfoDto } from '../models';
// @ts-ignore
import type { BackOfficeAccountBasicDto } from '../models';
// @ts-ignore
import type { BackOfficeAccountGetDto } from '../models';
// @ts-ignore
import type { BackOfficeAccountPatchDto } from '../models';
// @ts-ignore
import type { BackOfficeAccountStatusV5 } from '../models';
// @ts-ignore
import type { BackOfficeAgreementCreationDtoV8 } from '../models';
// @ts-ignore
import type { BackOfficeAgreementTypeV8 } from '../models';
// @ts-ignore
import type { BackOfficeCardCreditGetV2Dto } from '../models';
// @ts-ignore
import type { BackOfficeCardCreditPatchV2Dto } from '../models';
// @ts-ignore
import type { BackOfficeCardDeliveryAddressResponseDto } from '../models';
// @ts-ignore
import type { BackOfficeCardPatchDto } from '../models';
// @ts-ignore
import type { BackOfficeCardsDto } from '../models';
// @ts-ignore
import type { BackOfficeCreatePaymentForCustomerRequestDto } from '../models';
// @ts-ignore
import type { BackOfficeCustomerCreateDtoV2 } from '../models';
// @ts-ignore
import type { BackOfficeCustomerDtoV2 } from '../models';
// @ts-ignore
import type { BackOfficeCustomerKycRequiresRenewalDtoV2 } from '../models';
// @ts-ignore
import type { BackOfficeCustomerPatchDtoV2 } from '../models';
// @ts-ignore
import type { BackOfficeGoogleAuthResponseDto } from '../models';
// @ts-ignore
import type { BackOfficeOrderCardRequestDtoV3 } from '../models';
// @ts-ignore
import type { BackOfficePatchPaymentRequestDto } from '../models';
// @ts-ignore
import type { BackOfficePaymentDeclarationDecisionRequestV1Dto } from '../models';
// @ts-ignore
import type { BackOfficePaymentDeclarationV1Dto } from '../models';
// @ts-ignore
import type { BackOfficePaymentResponseDto } from '../models';
// @ts-ignore
import type { BackOfficePaymentWhiteListDto } from '../models';
// @ts-ignore
import type { BackOfficeReceiverInformationDto } from '../models';
// @ts-ignore
import type { BackOfficeSignatoryDto } from '../models';
// @ts-ignore
import type { BackOfficeSignatoryInfoResponseDto } from '../models';
// @ts-ignore
import type { BackOfficeTransactionConditionDto } from '../models';
// @ts-ignore
import type { BackOfficeTx2StatusFilter2 } from '../models';
// @ts-ignore
import type { BackofficeCardSyncResponseDto } from '../models';
// @ts-ignore
import type { BackofficeCreditApplicationCountV1Dto } from '../models';
// @ts-ignore
import type { BackofficeCreditApplicationProjectionResultV1Dto } from '../models';
// @ts-ignore
import type { BackofficeCreditApplicationV1Dto } from '../models';
// @ts-ignore
import type { BackofficeInvoicingConfigDto } from '../models';
// @ts-ignore
import type { BackofficeInvoicingConfigPatchDto } from '../models';
// @ts-ignore
import type { BackofficePisDepositEventResponseV1Dto } from '../models';
// @ts-ignore
import type { BackofficePisDepositResponseV1Dto } from '../models';
// @ts-ignore
import type { BankDataResponseDto } from '../models';
// @ts-ignore
import type { BillingSettings } from '../models';
// @ts-ignore
import type { BillingSettingsFeatureName } from '../models';
// @ts-ignore
import type { BillingSettingsFeatureOverridePatch } from '../models';
// @ts-ignore
import type { BillingSettingsFieldName } from '../models';
// @ts-ignore
import type { BillingSettingsOverridePatch } from '../models';
// @ts-ignore
import type { BillingSettingsTrialOverridePatch } from '../models';
// @ts-ignore
import type { BureauClientsPendingTaskAndAvailableResponse } from '../models';
// @ts-ignore
import type { BureauConfigRequest } from '../models';
// @ts-ignore
import type { BureauConfigResponse } from '../models';
// @ts-ignore
import type { BureauRelationshipRequest } from '../models';
// @ts-ignore
import type { BureauRelationshipResponse } from '../models';
// @ts-ignore
import type { BureauUnassingmentRequest } from '../models';
// @ts-ignore
import type { BureauUnassingmentResponse } from '../models';
// @ts-ignore
import type { CardBalanceConfigPatchDto } from '../models';
// @ts-ignore
import type { CardBalanceConfigResponseDto } from '../models';
// @ts-ignore
import type { CardConfig } from '../models';
// @ts-ignore
import type { CardConfigPatchRequestDto } from '../models';
// @ts-ignore
import type { CompanyChange } from '../models';
// @ts-ignore
import type { CompanyChangeRule } from '../models';
// @ts-ignore
import type { CorporateCustomerResponse } from '../models';
// @ts-ignore
import type { CreateAuthPersonForEmailDto } from '../models';
// @ts-ignore
import type { CreateDirectDebitMandateV4Request } from '../models';
// @ts-ignore
import type { CreatePasswordRequestDto } from '../models';
// @ts-ignore
import type { CreatePaymentRequestDtoV2 } from '../models';
// @ts-ignore
import type { CreatePersonDto } from '../models';
// @ts-ignore
import type { CreatePortfolioRequest } from '../models';
// @ts-ignore
import type { CustomerEventDto } from '../models';
// @ts-ignore
import type { CustomerNoteDto } from '../models';
// @ts-ignore
import type { DeDistrictCourtDto } from '../models';
// @ts-ignore
import type { DeleteAuthPersonDto } from '../models';
// @ts-ignore
import type { Direction } from '../models';
// @ts-ignore
import type { EInvoiceAddress } from '../models';
// @ts-ignore
import type { ExpenseCheckerMigrationResult } from '../models';
// @ts-ignore
import type { FastSearchResult } from '../models';
// @ts-ignore
import type { FetchRequestDto } from '../models';
// @ts-ignore
import type { FetchResponseDto } from '../models';
// @ts-ignore
import type { Field } from '../models';
// @ts-ignore
import type { FilexDto } from '../models';
// @ts-ignore
import type { GetAccountsV5200ResponseInner } from '../models';
// @ts-ignore
import type { GetAllAgreementsV8200ResponseInner } from '../models';
// @ts-ignore
import type { GetBoTransactionsV2DefaultResponseInner } from '../models';
// @ts-ignore
import type { GetDirectDebitMandatesV4200ResponseInner } from '../models';
// @ts-ignore
import type { InboxItemDto } from '../models';
// @ts-ignore
import type { InboxItemType } from '../models';
// @ts-ignore
import type { LatestSessionResponseDto } from '../models';
// @ts-ignore
import type { ListPlasticResponse } from '../models';
// @ts-ignore
import type { ListPrepaidAccountResponse } from '../models';
// @ts-ignore
import type { ListV3AccountResponse } from '../models';
// @ts-ignore
import type { MonitoringPortfolioCreditSafeMapping } from '../models';
// @ts-ignore
import type { MonitoringPortfolioUploadResponse } from '../models';
// @ts-ignore
import type { MonthlyReportLog } from '../models';
// @ts-ignore
import type { MonthlyReportRequest } from '../models';
// @ts-ignore
import type { NewBankDataSessionRequestDto } from '../models';
// @ts-ignore
import type { PaginatedAlarmsResponseDto } from '../models';
// @ts-ignore
import type { PatchPaymentRequestDtoV2 } from '../models';
// @ts-ignore
import type { PatchPrepaidResourceBody } from '../models';
// @ts-ignore
import type { PatchStandardResourceBody } from '../models';
// @ts-ignore
import type { PatchV3ResourceBody } from '../models';
// @ts-ignore
import type { PaymentRequestDtoV2 } from '../models';
// @ts-ignore
import type { PaymentRequestPdfDtoV2 } from '../models';
// @ts-ignore
import type { PaymentRequestStatusDtoV2 } from '../models';
// @ts-ignore
import type { PaymentState } from '../models';
// @ts-ignore
import type { PayoutRequestDto } from '../models';
// @ts-ignore
import type { PendingReason } from '../models';
// @ts-ignore
import type { PersonDto } from '../models';
// @ts-ignore
import type { PersonLoginRequest } from '../models';
// @ts-ignore
import type { PersonPatchDto } from '../models';
// @ts-ignore
import type { PersonsToDeleteAuthPersonIds } from '../models';
// @ts-ignore
import type { Portfolio } from '../models';
// @ts-ignore
import type { PrepaidAccountResponse } from '../models';
// @ts-ignore
import type { PrivateCustomerResponse } from '../models';
// @ts-ignore
import type { Request } from '../models';
// @ts-ignore
import type { RequestDto } from '../models';
// @ts-ignore
import type { RequestStatus } from '../models';
// @ts-ignore
import type { ResetRequest } from '../models';
// @ts-ignore
import type { ResetResponse } from '../models';
// @ts-ignore
import type { ResolveAlarmRequestDto } from '../models';
// @ts-ignore
import type { ResourceResponse } from '../models';
// @ts-ignore
import type { Result } from '../models';
// @ts-ignore
import type { SendEmailResponseDto } from '../models';
// @ts-ignore
import type { SetIdDomainRequest } from '../models';
// @ts-ignore
import type { SmsRequestDto } from '../models';
// @ts-ignore
import type { SmsTemplateDto } from '../models';
// @ts-ignore
import type { SnoozeDto } from '../models';
// @ts-ignore
import type { SubscriptionPlanUpgradeResponse } from '../models';
// @ts-ignore
import type { TextProcessorPatternDto } from '../models';
// @ts-ignore
import type { TextProcessorPatternPatchDto } from '../models';
// @ts-ignore
import type { TransactionDto } from '../models';
// @ts-ignore
import type { TransactionFilters } from '../models';
// @ts-ignore
import type { UpdateAuthPersonDto } from '../models';
// @ts-ignore
import type { UpdateAuthPersonMailDto } from '../models';
// @ts-ignore
import type { UpdateAuthPersonPhoneDto } from '../models';
// @ts-ignore
import type { UpdateRuleRequest } from '../models';
// @ts-ignore
import type { UploadRequest } from '../models';
// @ts-ignore
import type { UploadUrlDto } from '../models';
// @ts-ignore
import type { VisaCardListResponse } from '../models';
// @ts-ignore
import type { VisaCardResponse } from '../models';
// @ts-ignore
import type { VoucherDto } from '../models';
/**
 * BackOfficeAPIApi - axios parameter creator
 * @export
 */
export const BackOfficeAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/bo/sms-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsBasic: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('accountsBasic', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/v2/accounts-basic`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {string} plasticId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePlastic: async (customerId: string, cardId: string, plasticId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('activatePlastic', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('activatePlastic', 'cardId', cardId)
            // verify required parameter 'plasticId' is not null or undefined
            assertParamExists('activatePlastic', 'plasticId', plasticId)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}/plastics/{plastic-id}/activate`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)))
                .replace(`{${"plastic-id"}}`, encodeURIComponent(String(plasticId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateRule: async (portfolioId: string, countryCode: string, ruleCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('activateRule', 'portfolioId', portfolioId)
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('activateRule', 'countryCode', countryCode)
            // verify required parameter 'ruleCode' is not null or undefined
            assertParamExists('activateRule', 'ruleCode', ruleCode)
            const localVarPath = `/bo/credit-risk/monitoring/rules/portfolio/{portfolioId}/country/{countryCode}/rule/{ruleCode}/activate`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)))
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)))
                .replace(`{${"ruleCode"}}`, encodeURIComponent(String(ruleCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        add: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('add', 'body', body)
            const localVarPath = `/bo/sms-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        add1: async (customerId: string, body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('add1', 'customerId', customerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('add1', 'body', body)
            const localVarPath = `/bo/customers/{customerId}/notes`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} country 
         * @param {string} regNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyToPortfolio: async (portfolioId: string, country: string, regNo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('addCompanyToPortfolio', 'portfolioId', portfolioId)
            // verify required parameter 'country' is not null or undefined
            assertParamExists('addCompanyToPortfolio', 'country', country)
            // verify required parameter 'regNo' is not null or undefined
            assertParamExists('addCompanyToPortfolio', 'regNo', regNo)
            const localVarPath = `/bo/credit-risk/monitoring/{portfolioId}/companies/{country}/{regNo}`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)))
                .replace(`{${"regNo"}}`, encodeURIComponent(String(regNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFile: async (customerId: string, uploadRequest: UploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('addFile', 'customerId', customerId)
            // verify required parameter 'uploadRequest' is not null or undefined
            assertParamExists('addFile', 'uploadRequest', uploadRequest)
            const localVarPath = `/bo/customers/{customer-id}/files`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} itemId 
         * @param {SnoozeDto} snoozeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSnooze: async (itemId: string, snoozeDto: SnoozeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('addSnooze', 'itemId', itemId)
            // verify required parameter 'snoozeDto' is not null or undefined
            assertParamExists('addSnooze', 'snoozeDto', snoozeDto)
            const localVarPath = `/bo/snoozes/{item_id}`
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(snoozeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} validFrom 
         * @param {number} foodAndBeverageDeductionLimit 
         * @param {number} simpleFoodDeductionLimit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSwedishRepresentationVATValues: async (validFrom: string, foodAndBeverageDeductionLimit: number, simpleFoodDeductionLimit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validFrom' is not null or undefined
            assertParamExists('addSwedishRepresentationVATValues', 'validFrom', validFrom)
            // verify required parameter 'foodAndBeverageDeductionLimit' is not null or undefined
            assertParamExists('addSwedishRepresentationVATValues', 'foodAndBeverageDeductionLimit', foodAndBeverageDeductionLimit)
            // verify required parameter 'simpleFoodDeductionLimit' is not null or undefined
            assertParamExists('addSwedishRepresentationVATValues', 'simpleFoodDeductionLimit', simpleFoodDeductionLimit)
            const localVarPath = `/bo/representation/vat/swedish-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (validFrom !== undefined) {
                localVarQueryParameter['validFrom'] = (validFrom as any instanceof Date) ?
                    (validFrom as any).toISOString() :
                    validFrom;
            }

            if (foodAndBeverageDeductionLimit !== undefined) {
                localVarQueryParameter['foodAndBeverageDeductionLimit'] = foodAndBeverageDeductionLimit;
            }

            if (simpleFoodDeductionLimit !== undefined) {
                localVarQueryParameter['simpleFoodDeductionLimit'] = simpleFoodDeductionLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alreadyExistingException: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/test/already-existing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauRelationshipRequest} bureauRelationshipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assign: async (bureauRelationshipRequest: BureauRelationshipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bureauRelationshipRequest' is not null or undefined
            assertParamExists('assign', 'bureauRelationshipRequest', bureauRelationshipRequest)
            const localVarPath = `/bo/v1/bureau/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bureauRelationshipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backofficeRoleChecker: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/backoffice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PersonLoginRequest} personLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bizOpsLogin: async (personLoginRequest: PersonLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personLoginRequest' is not null or undefined
            assertParamExists('bizOpsLogin', 'personLoginRequest', personLoginRequest)
            const localVarPath = `/bo/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bureau: async (bureauId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bureauId' is not null or undefined
            assertParamExists('bureau', 'bureauId', bureauId)
            const localVarPath = `/bo/v1/bureau/{bureau-id}`
                .replace(`{${"bureau-id"}}`, encodeURIComponent(String(bureauId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bureauClients: async (bureauId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bureauId' is not null or undefined
            assertParamExists('bureauClients', 'bureauId', bureauId)
            const localVarPath = `/bo/v1/bureau/{bureau-id}/bureau-clients`
                .replace(`{${"bureau-id"}}`, encodeURIComponent(String(bureauId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bureauPendingTasks: async (bureauId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bureauId' is not null or undefined
            assertParamExists('bureauPendingTasks', 'bureauId', bureauId)
            const localVarPath = `/bo/v1/bureau/{bureau-id}/pending-tasks`
                .replace(`{${"bureau-id"}}`, encodeURIComponent(String(bureauId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDirectDebitMandateV4: async (customerId: string, mandateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('cancelDirectDebitMandateV4', 'customerId', customerId)
            // verify required parameter 'mandateId' is not null or undefined
            assertParamExists('cancelDirectDebitMandateV4', 'mandateId', mandateId)
            const localVarPath = `/bo/v4/customers/{customer-id}/direct-debit-mandates/{mandate-id}/cancel`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"mandate-id"}}`, encodeURIComponent(String(mandateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {string} userAgent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPisDeposit: async (customerId: string, depositId: string, userAgent: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('cancelPisDeposit', 'customerId', customerId)
            // verify required parameter 'depositId' is not null or undefined
            assertParamExists('cancelPisDeposit', 'depositId', depositId)
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('cancelPisDeposit', 'userAgent', userAgent)
            const localVarPath = `/bo/v1/customers/{customer-id}/pis-deposits/{deposit-id}/cancel`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"deposit-id"}}`, encodeURIComponent(String(depositId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (userAgent != null) {
                localVarHeaderParameter['User-Agent'] = String(userAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardDeliveryAddress: async (customerId: string, personId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('cardDeliveryAddress', 'customerId', customerId)
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('cardDeliveryAddress', 'personId', personId)
            const localVarPath = `/bo/customers/{customer-id}/card/card-address/{person-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"person-id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cards: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('cards', 'customerId', customerId)
            const localVarPath = `/bo/v1/customers/{customer-id}/cards`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary churn customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        churnCustomer: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('churnCustomer', 'customerId', customerId)
            const localVarPath = `/bo/v1/customers/{customer-id}/churn`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        client: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('client', 'clientId', clientId)
            const localVarPath = `/bo/v1/bureau/client/{client-id}`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauConfigRequest} bureauConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configure: async (bureauConfigRequest: BureauConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bureauConfigRequest' is not null or undefined
            assertParamExists('configure', 'bureauConfigRequest', bureauConfigRequest)
            const localVarPath = `/bo/v1/bureau/configure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bureauConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} [search] 
         * @param {string} [customerId] 
         * @param {Array<string>} [country] 
         * @param {Array<string>} [partner] 
         * @param {Array<string>} [kycStatus] 
         * @param {Array<RequestStatus>} [requestStatus] 
         * @param {Array<PendingReason>} [pendingReason] 
         * @param {boolean} [hasPendingReasons] 
         * @param {Array<AgreementStatus>} [agreementStatus] 
         * @param {boolean} [snoozed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCreditApplications: async (search?: string, customerId?: string, country?: Array<string>, partner?: Array<string>, kycStatus?: Array<string>, requestStatus?: Array<RequestStatus>, pendingReason?: Array<PendingReason>, hasPendingReasons?: boolean, agreementStatus?: Array<AgreementStatus>, snoozed?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/credit-applications/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (country) {
                localVarQueryParameter['country'] = Array.from(country);
            }

            if (partner) {
                localVarQueryParameter['partner'] = Array.from(partner);
            }

            if (kycStatus) {
                localVarQueryParameter['kycStatus'] = Array.from(kycStatus);
            }

            if (requestStatus) {
                localVarQueryParameter['requestStatus'] = Array.from(requestStatus);
            }

            if (pendingReason) {
                localVarQueryParameter['pendingReason'] = Array.from(pendingReason);
            }

            if (hasPendingReasons !== undefined) {
                localVarQueryParameter['hasPendingReasons'] = hasPendingReasons;
            }

            if (agreementStatus) {
                localVarQueryParameter['agreementStatus'] = Array.from(agreementStatus);
            }

            if (snoozed !== undefined) {
                localVarQueryParameter['snoozed'] = snoozed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {AccountDto} accountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (accountDto: AccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountDto' is not null or undefined
            assertParamExists('createAccount', 'accountDto', accountDto)
            const localVarPath = `/bo/accountx/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Create a new Agreement with status draft
         * @param {string} customerId 
         * @param {BackOfficeAgreementCreationDtoV8} backOfficeAgreementCreationDtoV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgreementV8: async (customerId: string, backOfficeAgreementCreationDtoV8: BackOfficeAgreementCreationDtoV8, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createAgreementV8', 'customerId', customerId)
            // verify required parameter 'backOfficeAgreementCreationDtoV8' is not null or undefined
            assertParamExists('createAgreementV8', 'backOfficeAgreementCreationDtoV8', backOfficeAgreementCreationDtoV8)
            const localVarPath = `/bo/v8/customers/{customer-id}/agreements`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeAgreementCreationDtoV8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreateAuthPersonForEmailDto} createAuthPersonForEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuthPersonForEmail: async (createAuthPersonForEmailDto: CreateAuthPersonForEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAuthPersonForEmailDto' is not null or undefined
            assertParamExists('createAuthPersonForEmail', 'createAuthPersonForEmailDto', createAuthPersonForEmailDto)
            const localVarPath = `/bo/authperson/migrate/create-auth-person-for-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAuthPersonForEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary create a new customer entity
         * @param {BackOfficeCustomerCreateDtoV2} backOfficeCustomerCreateDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: async (backOfficeCustomerCreateDtoV2: BackOfficeCustomerCreateDtoV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backOfficeCustomerCreateDtoV2' is not null or undefined
            assertParamExists('createCustomer', 'backOfficeCustomerCreateDtoV2', backOfficeCustomerCreateDtoV2)
            const localVarPath = `/bo/v2/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeCustomerCreateDtoV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {CreateDirectDebitMandateV4Request} createDirectDebitMandateV4Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectDebitMandateV4: async (customerId: string, createDirectDebitMandateV4Request: CreateDirectDebitMandateV4Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createDirectDebitMandateV4', 'customerId', customerId)
            // verify required parameter 'createDirectDebitMandateV4Request' is not null or undefined
            assertParamExists('createDirectDebitMandateV4', 'createDirectDebitMandateV4Request', createDirectDebitMandateV4Request)
            const localVarPath = `/bo/v4/customers/{customer-id}/direct-debit-mandates`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDirectDebitMandateV4Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreatePasswordRequestDto} createPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasswords: async (createPasswordRequestDto: CreatePasswordRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPasswordRequestDto' is not null or undefined
            assertParamExists('createPasswords', 'createPasswordRequestDto', createPasswordRequestDto)
            const localVarPath = `/bo/authperson/migrate/create-passwords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPasswordRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BackOfficeCreatePaymentForCustomerRequestDto} backOfficeCreatePaymentForCustomerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayment: async (backOfficeCreatePaymentForCustomerRequestDto: BackOfficeCreatePaymentForCustomerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backOfficeCreatePaymentForCustomerRequestDto' is not null or undefined
            assertParamExists('createPayment', 'backOfficeCreatePaymentForCustomerRequestDto', backOfficeCreatePaymentForCustomerRequestDto)
            const localVarPath = `/bo/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeCreatePaymentForCustomerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {CreatePersonDto} createPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonWithRoles: async (id: string, createPersonDto: CreatePersonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPersonWithRoles', 'id', id)
            // verify required parameter 'createPersonDto' is not null or undefined
            assertParamExists('createPersonWithRoles', 'createPersonDto', createPersonDto)
            const localVarPath = `/bo/customers/{id}/persons`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPersonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePortfolioRequest} createPortfolioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortfolio: async (createPortfolioRequest: CreatePortfolioRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPortfolioRequest' is not null or undefined
            assertParamExists('createPortfolio', 'createPortfolioRequest', createPortfolioRequest)
            const localVarPath = `/bo/credit-risk/monitoring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPortfolioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Create new signatories data
         * @param {string} customerId 
         * @param {Array<BackOfficeSignatoryDto>} backOfficeSignatoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSignatories: async (customerId: string, backOfficeSignatoryDto: Array<BackOfficeSignatoryDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createSignatories', 'customerId', customerId)
            // verify required parameter 'backOfficeSignatoryDto' is not null or undefined
            assertParamExists('createSignatories', 'backOfficeSignatoryDto', backOfficeSignatoryDto)
            const localVarPath = `/bo/v1/customers/{customer-id}/signatories`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeSignatoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreatePaymentRequestDtoV2} createPaymentRequestDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createV2: async (createPaymentRequestDtoV2: CreatePaymentRequestDtoV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPaymentRequestDtoV2' is not null or undefined
            assertParamExists('createV2', 'createPaymentRequestDtoV2', createPaymentRequestDtoV2)
            const localVarPath = `/bo/v2/payment-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentRequestDtoV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {VoucherDto} voucherDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoucher: async (voucherDto: VoucherDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voucherDto' is not null or undefined
            assertParamExists('createVoucher', 'voucherDto', voucherDto)
            const localVarPath = `/bo/accountx/vouchers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voucherDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {AccountXYear} accountXYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createYear: async (accountXYear: AccountXYear, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountXYear' is not null or undefined
            assertParamExists('createYear', 'accountXYear', accountXYear)
            const localVarPath = `/bo/accountx/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountXYear, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateRule: async (portfolioId: string, countryCode: string, ruleCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('deactivateRule', 'portfolioId', portfolioId)
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('deactivateRule', 'countryCode', countryCode)
            // verify required parameter 'ruleCode' is not null or undefined
            assertParamExists('deactivateRule', 'ruleCode', ruleCode)
            const localVarPath = `/bo/credit-risk/monitoring/rules/portfolio/{portfolioId}/country/{countryCode}/rule/{ruleCode}/deactivate`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)))
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)))
                .replace(`{${"ruleCode"}}`, encodeURIComponent(String(ruleCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1: async (customerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('delete1', 'customerId', customerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete1', 'id', id)
            const localVarPath = `/bo/customers/{customerId}/notes/{id}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAccount', 'id', id)
            const localVarPath = `/bo/accountx/accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {PersonsToDeleteAuthPersonIds} personsToDeleteAuthPersonIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthPerson: async (personsToDeleteAuthPersonIds: PersonsToDeleteAuthPersonIds, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personsToDeleteAuthPersonIds' is not null or undefined
            assertParamExists('deleteAuthPerson', 'personsToDeleteAuthPersonIds', personsToDeleteAuthPersonIds)
            const localVarPath = `/bo/authperson/migrate-bankid/delete-authperson-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personsToDeleteAuthPersonIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomer', 'customerId', customerId)
            const localVarPath = `/bo/v2/customers/{customer-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} authpersonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExistingAuthPerson: async (authpersonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authpersonId' is not null or undefined
            assertParamExists('deleteExistingAuthPerson', 'authpersonId', authpersonId)
            const localVarPath = `/bo/authperson/{authperson-id}`
                .replace(`{${"authperson-id"}}`, encodeURIComponent(String(authpersonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFeatureName} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeatureOverride: async (customerId: string, featureName: BillingSettingsFeatureName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteFeatureOverride', 'customerId', customerId)
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists('deleteFeatureOverride', 'featureName', featureName)
            const localVarPath = `/bo/v1/customers/{customer-id}/billing-settings/overrides/features/{feature-name}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"feature-name"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (customerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteFile', 'customerId', customerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFile', 'id', id)
            const localVarPath = `/bo/customers/{customer-id}/files/{id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFieldName} fieldName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOverrides: async (customerId: string, fieldName: BillingSettingsFieldName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteOverrides', 'customerId', customerId)
            // verify required parameter 'fieldName' is not null or undefined
            assertParamExists('deleteOverrides', 'fieldName', fieldName)
            const localVarPath = `/bo/v1/customers/{customer-id}/billing-settings/overrides/{field-name}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"field-name"}}`, encodeURIComponent(String(fieldName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} paymentWhiteListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentWhiteListV1: async (customerId: string, paymentWhiteListId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deletePaymentWhiteListV1', 'customerId', customerId)
            // verify required parameter 'paymentWhiteListId' is not null or undefined
            assertParamExists('deletePaymentWhiteListV1', 'paymentWhiteListId', paymentWhiteListId)
            const localVarPath = `/bo/v1/customers/{customer-id}/payment-white-list/{payment-white-list-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"payment-white-list-id"}}`, encodeURIComponent(String(paymentWhiteListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePerson: async (id: string, personId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePerson', 'id', id)
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('deletePerson', 'personId', personId)
            const localVarPath = `/bo/customers/{id}/persons/{person-id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"person-id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreorderCardV1: async (customerId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deletePreorderCardV1', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('deletePreorderCardV1', 'cardId', cardId)
            const localVarPath = `/bo/v1/customers/{customer-id}/cards/{card-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSnooze: async (itemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('deleteSnooze', 'itemId', itemId)
            const localVarPath = `/bo/snoozes/{item_id}`
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextProcessorConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTextProcessorConfiguration', 'id', id)
            const localVarPath = `/bo/v1/text-processor/patterns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteYear: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteYear', 'id', id)
            const localVarPath = `/bo/accountx/years/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directLoginToken: async (id: string, personId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('directLoginToken', 'id', id)
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('directLoginToken', 'personId', personId)
            const localVarPath = `/bo/customers/{id}/persons/{person-id}/direct-login`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"person-id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FetchRequestDto} fetchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetch: async (fetchRequestDto: FetchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchRequestDto' is not null or undefined
            assertParamExists('fetch', 'fetchRequestDto', fetchRequestDto)
            const localVarPath = `/bo/bank-data/fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAndSaveNotifications: async (fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('fetchAndSaveNotifications', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('fetchAndSaveNotifications', 'toDate', toDate)
            const localVarPath = `/bo/credit-risk/monitoring/notifications/fetch-and-save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/sms-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBy: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('findBy', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customerId}/notes`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary List audit logs
         * @param {string} [customerId] 
         * @param {string} [resourceId] 
         * @param {Array<string>} [hierarchyElement] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByCustomerId: async (customerId?: string, resourceId?: string, hierarchyElement?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/audits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customer-id'] = customerId;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resource-id'] = resourceId;
            }

            if (hierarchyElement) {
                localVarQueryParameter['hierarchy-element'] = hierarchyElement;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary fetch a customer entity by id
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomerById: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('findCustomerById', 'customerId', customerId)
            const localVarPath = `/bo/v2/customers/{customer-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEInvoiceAddresses: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('findEInvoiceAddresses', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/e-invoice-address`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forbiddenException: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/test/access-denied`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalException: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/test/general-exception`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            const localVarPath = `/bo/sms-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1: async (customerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('get1', 'customerId', customerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get1', 'id', id)
            const localVarPath = `/bo/customers/{customerId}/notes/{id}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccount: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccount', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/account`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccount3: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccount3', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/account3`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get an accounts balance, available, and creditlimit. This requires a downstream call to enfuce.
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountStatusV5: async (customerId: string, accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccountStatusV5', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountStatusV5', 'accountId', accountId)
            const localVarPath = `/bo/v5/customers/{customer-id}/accounts/{account-id}/status`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountV2: async (customerId: string, accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccountV2', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountV2', 'accountId', accountId)
            const localVarPath = `/bo/customers/{customer-id}/card/v2/accounts/{account-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get an account on customer
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountV5: async (customerId: string, accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccountV5', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountV5', 'accountId', accountId)
            const localVarPath = `/bo/v5/customers/{customer-id}/accounts/{account-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: async (year?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/accountx/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsV2: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccountsV2', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/v2/accounts`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get a list of all accounts on customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsV5: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccountsV5', 'customerId', customerId)
            const localVarPath = `/bo/v5/customers/{customer-id}/accounts`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivationGuide: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getActivationGuide', 'customerId', customerId)
            const localVarPath = `/bo/v2/customers/{customer-id}/activation-guide`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivationGuideVisibility: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getActivationGuideVisibility', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/activation-guide`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveAlarms: async (pageNumber?: number, pageSize?: number, sortDirection?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/credit-risk/alarms/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSessions: async (pageSize?: number, pageNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/bank-data/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Get agreement details for given agreement-id
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementV8: async (customerId: string, agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAgreementV8', 'customerId', customerId)
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getAgreementV8', 'agreementId', agreementId)
            const localVarPath = `/bo/v8/customers/{customer-id}/agreements/{agreement-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"agreement-id"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlarmById: async (alarmId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alarmId' is not null or undefined
            assertParamExists('getAlarmById', 'alarmId', alarmId)
            const localVarPath = `/bo/credit-risk/alarms/{alarmId}`
                .replace(`{${"alarmId"}}`, encodeURIComponent(String(alarmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlarmsByCustomerId: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAlarmsByCustomerId', 'customerId', customerId)
            const localVarPath = `/bo/credit-risk/alarms/customer/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get a list of all agreements on customer
         * @param {string} customerId 
         * @param {Array<BackOfficeAgreementTypeV8>} [agreementType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreementsV8: async (customerId: string, agreementType?: Array<BackOfficeAgreementTypeV8>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAllAgreementsV8', 'customerId', customerId)
            const localVarPath = `/bo/v8/customers/{customer-id}/agreements`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agreementType) {
                localVarQueryParameter['agreement-type'] = Array.from(agreementType);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [status] 
         * @param {string} [companyName] 
         * @param {string} [sortDirection] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlarms: async (pageNumber?: number, pageSize?: number, status?: string, companyName?: string, sortDirection?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/credit-risk/alarms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContexts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/customers/files/contexts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEventRules: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/credit-risk/monitoring/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMonthlyReports: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAllMonthlyReports', 'customerId', customerId)
            const localVarPath = `/bo/customer/{customer-id}/card/transactions/pe/monthly-reports`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificationEvents: async (fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/credit-risk/monitoring/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTextProcessorConfigurations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/text-processor/patterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [years] 
         * @param {Array<number>} [accounts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVouchers: async (from?: string, to?: string, years?: Array<string>, accounts?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/accountx/vouchers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (years) {
                localVarQueryParameter['years'] = years;
            }

            if (accounts) {
                localVarQueryParameter['accounts'] = accounts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authpersonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthPersonInfo: async (authpersonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authpersonId' is not null or undefined
            assertParamExists('getAuthPersonInfo', 'authpersonId', authpersonId)
            const localVarPath = `/bo/authperson/{authperson-id}`
                .replace(`{${"authperson-id"}}`, encodeURIComponent(String(authpersonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Offset, start transaction list at this offset. Limit is how many transactions to return. transactionDate do not have a timezone
         * @param {string} customerId 
         * @param {number} [offset] pagination offset
         * @param {number} [limit] pagination limit
         * @param {string} [from] from date (inclusive) in ISO format, yyyy-MM-dd
         * @param {string} [to] to date (inclusive) in ISO format, yyyy-MM-dd
         * @param {number} [min] min transaction amount (inclusive)
         * @param {number} [max] max transaction amount (inclusive)
         * @param {Array<TransactionFilters>} [onlyinclude] various transaction property filters, some are mutually exclusive
         * @param {Array<TransactionFilters>} [exclude] 
         * @param {Array<AttestStatus>} [attestStatus] 
         * @param {string} [query] Free text query search. At least 3 characters, otherwise ignored
         * @param {Array<string>} [personIds] \&#39;or-ed\&#39; person id\&#39;s to query for, if omitted then transactions for all users will be returned. note: returned set increases with with more personIds and decreases with less personId, except for the empty set which returns all transactions
         * @param {Array<string>} [cardIds] 
         * @param {Array<BackOfficeTx2StatusFilter2>} [status] Filter on transaction status. Leave empty to include all statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoTransactionsV2: async (customerId: string, offset?: number, limit?: number, from?: string, to?: string, min?: number, max?: number, onlyinclude?: Array<TransactionFilters>, exclude?: Array<TransactionFilters>, attestStatus?: Array<AttestStatus>, query?: string, personIds?: Array<string>, cardIds?: Array<string>, status?: Array<BackOfficeTx2StatusFilter2>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getBoTransactionsV2', 'customerId', customerId)
            const localVarPath = `/bo/v2/customers/{customer-id}/transactions`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (min !== undefined) {
                localVarQueryParameter['min'] = min;
            }

            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }

            if (onlyinclude) {
                localVarQueryParameter['onlyinclude'] = Array.from(onlyinclude);
            }

            if (exclude) {
                localVarQueryParameter['exclude'] = Array.from(exclude);
            }

            if (attestStatus) {
                localVarQueryParameter['attest-status'] = Array.from(attestStatus);
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (personIds) {
                localVarQueryParameter['person-ids'] = Array.from(personIds);
            }

            if (cardIds) {
                localVarQueryParameter['card-ids'] = cardIds;
            }

            if (status) {
                localVarQueryParameter['status'] = Array.from(status);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerId: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getByCustomerId', 'customerId', customerId)
            const localVarPath = `/bo/bank-data/get-by-customer-id/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard: async (customerId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCard', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCard', 'cardId', cardId)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardBalanceConfig: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCardBalanceConfig', 'customerId', customerId)
            const localVarPath = `/bo/v2/customers/{customer-id}/card/card-balance-config`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardConfig: async (customerId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCardConfig', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCardConfig', 'cardId', cardId)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}/config`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardCreditV2: async (customerId: string, creditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCardCreditV2', 'customerId', customerId)
            // verify required parameter 'creditId' is not null or undefined
            assertParamExists('getCardCreditV2', 'creditId', creditId)
            const localVarPath = `/bo/customers/{customer-id}/v2/card-credits/{credit-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"credit-id"}}`, encodeURIComponent(String(creditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardCreditsV2: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCardCreditsV2', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/v2/card-credits`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardPlastics: async (customerId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCardPlastics', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCardPlastics', 'cardId', cardId)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}/plastics`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardV1: async (customerId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCardV1', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCardV1', 'cardId', cardId)
            const localVarPath = `/bo/v1/customers/{customer-id}/cards/{card-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCards: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCards', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/cards`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateCustomer: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCorporateCustomer', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/corporate`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditApplication: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getCreditApplication', 'requestId', requestId)
            const localVarPath = `/bo/v1/credit-applications/{request-id}`
                .replace(`{${"request-id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectDebitMandatesV4: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getDirectDebitMandatesV4', 'customerId', customerId)
            const localVarPath = `/bo/v4/customers/{customer-id}/direct-debit-mandates`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventRulesByCountry: async (countryCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getEventRulesByCountry', 'countryCode', countryCode)
            const localVarPath = `/bo/credit-risk/monitoring/rules/country/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventRulesForPortfolio: async (portfolioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getEventRulesForPortfolio', 'portfolioId', portfolioId)
            const localVarPath = `/bo/credit-risk/monitoring/rules/portfolio/{portfolioId}`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventRulesForPortfolioAndCountry: async (portfolioId: string, countryCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getEventRulesForPortfolioAndCountry', 'portfolioId', portfolioId)
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getEventRulesForPortfolioAndCountry', 'countryCode', countryCode)
            const localVarPath = `/bo/credit-risk/monitoring/rules/portfolio/{portfolioId}/country/{countryCode}`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)))
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {Array<string>} [contexts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiles: async (customerId: string, contexts?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getFiles', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/files`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contexts) {
                localVarQueryParameter['contexts'] = contexts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGermanyDistrictCourtCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/create-customer-options/german-district-court`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Array<InboxItemType>} [types] Filter for specific types. Accepts a comma separated list. If omitted, all types are returned
         * @param {boolean} [snoozed] should snoozed items be included or not
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getInbox: async (types?: Array<InboxItemType>, snoozed?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/inbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (snoozed !== undefined) {
                localVarQueryParameter['snoozed'] = snoozed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicingConfigV1: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getInvoicingConfigV1', 'customerId', customerId)
            const localVarPath = `/bo/v1/customers/{customer-id}/invoicing-config`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSession: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getLatestSession', 'customerId', customerId)
            const localVarPath = `/bo/bank-data/get-latest-session/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartners: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayment: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('getPayment', 'paymentId', paymentId)
            const localVarPath = `/bo/payments/{payment-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDeclaration: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('getPaymentDeclaration', 'submissionId', submissionId)
            const localVarPath = `/bo/v1/payment-declarations/{submission-id}`
                .replace(`{${"submission-id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReceiverV1: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('getPaymentReceiverV1', 'paymentId', paymentId)
            const localVarPath = `/bo/payments/{payment-id}/receiver`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestV2: async (paymentRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestV2', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/bo/v2/payment-request/{payment-request-id}`
                .replace(`{${"payment-request-id"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [customerId] 
         * @param {string} [cardCreditId] 
         * @param {Array<string>} [currency] 
         * @param {boolean} [hasPaidEnough] 
         * @param {Array<PaymentRequestStatusDtoV2>} [status] 
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {string} [paymentRequestDateFrom] 
         * @param {string} [paymentRequestDateTo] 
         * @param {string} [periodFrom] 
         * @param {string} [periodTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsV2: async (customerId?: string, cardCreditId?: string, currency?: Array<string>, hasPaidEnough?: boolean, status?: Array<PaymentRequestStatusDtoV2>, dueDateFrom?: string, dueDateTo?: string, paymentRequestDateFrom?: string, paymentRequestDateTo?: string, periodFrom?: string, periodTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v2/payment-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customer-id'] = customerId;
            }

            if (cardCreditId !== undefined) {
                localVarQueryParameter['card-credit-id'] = cardCreditId;
            }

            if (currency) {
                localVarQueryParameter['currency'] = Array.from(currency);
            }

            if (hasPaidEnough !== undefined) {
                localVarQueryParameter['has-paid-enough'] = hasPaidEnough;
            }

            if (status) {
                localVarQueryParameter['status'] = Array.from(status);
            }

            if (dueDateFrom !== undefined) {
                localVarQueryParameter['due-date-from'] = (dueDateFrom as any instanceof Date) ?
                    (dueDateFrom as any).toISOString().substring(0,10) :
                    dueDateFrom;
            }

            if (dueDateTo !== undefined) {
                localVarQueryParameter['due-date-to'] = (dueDateTo as any instanceof Date) ?
                    (dueDateTo as any).toISOString().substring(0,10) :
                    dueDateTo;
            }

            if (paymentRequestDateFrom !== undefined) {
                localVarQueryParameter['payment-request-date-from'] = (paymentRequestDateFrom as any instanceof Date) ?
                    (paymentRequestDateFrom as any).toISOString().substring(0,10) :
                    paymentRequestDateFrom;
            }

            if (paymentRequestDateTo !== undefined) {
                localVarQueryParameter['payment-request-date-to'] = (paymentRequestDateTo as any instanceof Date) ?
                    (paymentRequestDateTo as any).toISOString().substring(0,10) :
                    paymentRequestDateTo;
            }

            if (periodFrom !== undefined) {
                localVarQueryParameter['period-from'] = (periodFrom as any instanceof Date) ?
                    (periodFrom as any).toISOString().substring(0,10) :
                    periodFrom;
            }

            if (periodTo !== undefined) {
                localVarQueryParameter['period-to'] = (periodTo as any instanceof Date) ?
                    (periodTo as any).toISOString().substring(0,10) :
                    periodTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentWhiteListV1: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getPaymentWhiteListV1', 'customerId', customerId)
            const localVarPath = `/bo/v1/customers/{customer-id}/payment-white-list`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Array<PaymentState>} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments: async (state?: Array<PaymentState>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutRequest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPayoutRequest', 'id', id)
            const localVarPath = `/bo/manual-payout/requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfV2: async (paymentRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPdfV2', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/bo/v2/payment-request/{payment-request-id}/pdf`
                .replace(`{${"payment-request-id"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonsWithRoles: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonsWithRoles', 'id', id)
            const localVarPath = `/bo/customers/{id}/persons`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSignedUrl: async (customerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getPreSignedUrl', 'customerId', customerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPreSignedUrl', 'id', id)
            const localVarPath = `/bo/customers/{customer-id}/files/{id}/url`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferredDirectDebitMandateV4: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getPreferredDirectDebitMandateV4', 'customerId', customerId)
            const localVarPath = `/bo/v4/customers/{customer-id}/direct-debit-mandates/preferred`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivateCustomers: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getPrivateCustomers', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/private`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawAccountV3: async (customerId: string, accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getRawAccountV3', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getRawAccountV3', 'accountId', accountId)
            const localVarPath = `/bo/customers/{customer-id}/card/raw/accounts/v3/{account-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawAccountV4: async (customerId: string, accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getRawAccountV4', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getRawAccountV4', 'accountId', accountId)
            const localVarPath = `/bo/customers/{customer-id}/card/raw/accounts/v4/{account-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawAccountsV3: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getRawAccountsV3', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/raw/accounts/v3`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawAccountsV4: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getRawAccountsV4', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/raw/accounts/v4`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgNo 
         * @param {string} country 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedNotifications: async (orgNo: string, country: string, fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgNo' is not null or undefined
            assertParamExists('getSavedNotifications', 'orgNo', orgNo)
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getSavedNotifications', 'country', country)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getSavedNotifications', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getSavedNotifications', 'toDate', toDate)
            const localVarPath = `/bo/credit-risk/monitoring/notifications/saved`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgNo !== undefined) {
                localVarQueryParameter['orgNo'] = orgNo;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get signatories data
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignatories: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getSignatories', 'customerId', customerId)
            const localVarPath = `/bo/v1/customers/{customer-id}/signatories`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction: async (customerId: string, txId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getTransaction', 'customerId', customerId)
            // verify required parameter 'txId' is not null or undefined
            assertParamExists('getTransaction', 'txId', txId)
            const localVarPath = `/bo/customers/{customer-id}/card/transactions/{tx-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"tx-id"}}`, encodeURIComponent(String(txId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary offset takes precedence over page if provided. Page is still available for backward compatibility. limit defaults to 20
         * @param {string} customerId 
         * @param {number} [page] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsCombined: async (customerId: string, page?: number, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getTransactionsCombined', 'customerId', customerId)
            const localVarPath = `/bo/customers/{customer-id}/card/transactions`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpgradeOption: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getUpgradeOption', 'customerId', customerId)
            const localVarPath = `/bo/v1/customers/{customer-id}/billing-settings/upgrade-option`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [years] 
         * @param {Array<number>} [accounts] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVouchersResultReport: async (from?: string, to?: string, years?: Array<string>, accounts?: Array<number>, currency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/accountx/vouchers/result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (years) {
                localVarQueryParameter['years'] = years;
            }

            if (accounts) {
                localVarQueryParameter['accounts'] = accounts;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYears: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/accountx/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleOAuthRedir: async (callback: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callback' is not null or undefined
            assertParamExists('googleOAuthRedir', 'callback', callback)
            const localVarPath = `/bo/authenticate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (callback !== undefined) {
                localVarQueryParameter['callback'] = callback;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illegalArgumentException: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/test/illegal-argument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illegalStateException: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/test/illegal-state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {string} userAgent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectPisDeposit: async (customerId: string, depositId: string, userAgent: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('inspectPisDeposit', 'customerId', customerId)
            // verify required parameter 'depositId' is not null or undefined
            assertParamExists('inspectPisDeposit', 'depositId', depositId)
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('inspectPisDeposit', 'userAgent', userAgent)
            const localVarPath = `/bo/v1/customers/{customer-id}/pis-deposits/{deposit-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"deposit-id"}}`, encodeURIComponent(String(depositId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (userAgent != null) {
                localVarHeaderParameter['User-Agent'] = String(userAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isLoggedIn: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/is-logged-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kycApproved: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('kycApproved', 'customerId', customerId)
            const localVarPath = `/bo/v2/customers/{customer-id}/notify-kyc-approved`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackOfficeCustomerKycRequiresRenewalDtoV2} backOfficeCustomerKycRequiresRenewalDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kycRequiresRenewal: async (customerId: string, backOfficeCustomerKycRequiresRenewalDtoV2: BackOfficeCustomerKycRequiresRenewalDtoV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('kycRequiresRenewal', 'customerId', customerId)
            // verify required parameter 'backOfficeCustomerKycRequiresRenewalDtoV2' is not null or undefined
            assertParamExists('kycRequiresRenewal', 'backOfficeCustomerKycRequiresRenewalDtoV2', backOfficeCustomerKycRequiresRenewalDtoV2)
            const localVarPath = `/bo/v2/customers/{customer-id}/notify-kyc-requires-renewal`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeCustomerKycRequiresRenewalDtoV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/bureau`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} [searchQuery] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompaniesInPortfolio: async (portfolioId: string, searchQuery?: string, pageSize?: number, page?: number, countryCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('listCompaniesInPortfolio', 'portfolioId', portfolioId)
            const localVarPath = `/bo/credit-risk/monitoring/{portfolioId}/companies`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPisDepositEvents: async (customerId: string, depositId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('listPisDepositEvents', 'customerId', customerId)
            // verify required parameter 'depositId' is not null or undefined
            assertParamExists('listPisDepositEvents', 'depositId', depositId)
            const localVarPath = `/bo/v1/customers/{customer-id}/pis-deposits/{deposit-id}/events`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"deposit-id"}}`, encodeURIComponent(String(depositId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPisDeposits: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('listPisDeposits', 'customerId', customerId)
            const localVarPath = `/bo/v1/customers/{customer-id}/pis-deposits`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPortfolios: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/credit-risk/monitoring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        log: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('log', 'id', id)
            const localVarPath = `/bo/customers/{id}/log`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAlarmUnderReview: async (alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alarmId' is not null or undefined
            assertParamExists('markAlarmUnderReview', 'alarmId', alarmId)
            // verify required parameter 'resolveAlarmRequestDto' is not null or undefined
            assertParamExists('markAlarmUnderReview', 'resolveAlarmRequestDto', resolveAlarmRequestDto)
            const localVarPath = `/bo/credit-risk/alarms/{alarmId}/under-review`
                .replace(`{${"alarmId"}}`, encodeURIComponent(String(alarmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveAlarmRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAuth0Users: async (requestDto: RequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDto' is not null or undefined
            assertParamExists('migrateAuth0Users', 'requestDto', requestDto)
            const localVarPath = `/bo/authperson/migrate/create-auth-persons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notFoundException: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/test/not-found`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyCardCreditDenied: async (customerId: string, creditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('notifyCardCreditDenied', 'customerId', customerId)
            // verify required parameter 'creditId' is not null or undefined
            assertParamExists('notifyCardCreditDenied', 'creditId', creditId)
            const localVarPath = `/bo/customers/{customer-id}/v2/card-credits/{credit-id}/notify-denied`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"credit-id"}}`, encodeURIComponent(String(creditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyCardCreditRaiseDenied: async (customerId: string, creditId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('notifyCardCreditRaiseDenied', 'customerId', customerId)
            // verify required parameter 'creditId' is not null or undefined
            assertParamExists('notifyCardCreditRaiseDenied', 'creditId', creditId)
            const localVarPath = `/bo/customers/{customer-id}/v2/card-credits/{credit-id}/notify-raise-denied`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"credit-id"}}`, encodeURIComponent(String(creditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackOfficeOrderCardRequestDtoV3} backOfficeOrderCardRequestDtoV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCardV3: async (customerId: string, backOfficeOrderCardRequestDtoV3: BackOfficeOrderCardRequestDtoV3, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('orderCardV3', 'customerId', customerId)
            // verify required parameter 'backOfficeOrderCardRequestDtoV3' is not null or undefined
            assertParamExists('orderCardV3', 'backOfficeOrderCardRequestDtoV3', backOfficeOrderCardRequestDtoV3)
            const localVarPath = `/bo/customers/{customer-id}/v3/card/order`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeOrderCardRequestDtoV3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {PatchPrepaidResourceBody} patchPrepaidResourceBody 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchAccount: async (customerId: string, patchPrepaidResourceBody: PatchPrepaidResourceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchAccount', 'customerId', customerId)
            // verify required parameter 'patchPrepaidResourceBody' is not null or undefined
            assertParamExists('patchAccount', 'patchPrepaidResourceBody', patchPrepaidResourceBody)
            const localVarPath = `/bo/customers/{customer-id}/card/account`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchPrepaidResourceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {BackOfficeAccountPatchDto} backOfficeAccountPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountV2: async (customerId: string, accountId: string, backOfficeAccountPatchDto: BackOfficeAccountPatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchAccountV2', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('patchAccountV2', 'accountId', accountId)
            // verify required parameter 'backOfficeAccountPatchDto' is not null or undefined
            assertParamExists('patchAccountV2', 'backOfficeAccountPatchDto', backOfficeAccountPatchDto)
            const localVarPath = `/bo/customers/{customer-id}/card/v2/accounts/{account-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeAccountPatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {ActivationGuidePatchDto} activationGuidePatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivationGuideVisibility: async (customerId: string, activationGuidePatchDto: ActivationGuidePatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchActivationGuideVisibility', 'customerId', customerId)
            // verify required parameter 'activationGuidePatchDto' is not null or undefined
            assertParamExists('patchActivationGuideVisibility', 'activationGuidePatchDto', activationGuidePatchDto)
            const localVarPath = `/bo/v2/customers/{customer-id}/activation-guide`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activationGuidePatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {ActivationGuidePatchDto} activationGuidePatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivationGuideVisibility1: async (customerId: string, activationGuidePatchDto: ActivationGuidePatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchActivationGuideVisibility1', 'customerId', customerId)
            // verify required parameter 'activationGuidePatchDto' is not null or undefined
            assertParamExists('patchActivationGuideVisibility1', 'activationGuidePatchDto', activationGuidePatchDto)
            const localVarPath = `/bo/customers/{customer-id}/activation-guide`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activationGuidePatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {PatchStandardResourceBody} patchStandardResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCard: async (customerId: string, cardId: string, patchStandardResourceBody: PatchStandardResourceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchCard', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('patchCard', 'cardId', cardId)
            // verify required parameter 'patchStandardResourceBody' is not null or undefined
            assertParamExists('patchCard', 'patchStandardResourceBody', patchStandardResourceBody)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchStandardResourceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {CardBalanceConfigPatchDto} cardBalanceConfigPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCardBalanceConfig: async (customerId: string, cardBalanceConfigPatchDto: CardBalanceConfigPatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchCardBalanceConfig', 'customerId', customerId)
            // verify required parameter 'cardBalanceConfigPatchDto' is not null or undefined
            assertParamExists('patchCardBalanceConfig', 'cardBalanceConfigPatchDto', cardBalanceConfigPatchDto)
            const localVarPath = `/bo/v2/customers/{customer-id}/card/card-balance-config`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardBalanceConfigPatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {CardConfigPatchRequestDto} cardConfigPatchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCardConfig: async (customerId: string, cardId: string, cardConfigPatchRequestDto: CardConfigPatchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchCardConfig', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('patchCardConfig', 'cardId', cardId)
            // verify required parameter 'cardConfigPatchRequestDto' is not null or undefined
            assertParamExists('patchCardConfig', 'cardConfigPatchRequestDto', cardConfigPatchRequestDto)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}/config`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardConfigPatchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {BackOfficeCardCreditPatchV2Dto} backOfficeCardCreditPatchV2Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCardCreditV2: async (customerId: string, creditId: string, backOfficeCardCreditPatchV2Dto: BackOfficeCardCreditPatchV2Dto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchCardCreditV2', 'customerId', customerId)
            // verify required parameter 'creditId' is not null or undefined
            assertParamExists('patchCardCreditV2', 'creditId', creditId)
            // verify required parameter 'backOfficeCardCreditPatchV2Dto' is not null or undefined
            assertParamExists('patchCardCreditV2', 'backOfficeCardCreditPatchV2Dto', backOfficeCardCreditPatchV2Dto)
            const localVarPath = `/bo/customers/{customer-id}/v2/card-credits/{credit-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"credit-id"}}`, encodeURIComponent(String(creditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeCardCreditPatchV2Dto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {BackOfficeCardPatchDto} backOfficeCardPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCardV1: async (customerId: string, cardId: string, backOfficeCardPatchDto: BackOfficeCardPatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchCardV1', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('patchCardV1', 'cardId', cardId)
            // verify required parameter 'backOfficeCardPatchDto' is not null or undefined
            assertParamExists('patchCardV1', 'backOfficeCardPatchDto', backOfficeCardPatchDto)
            const localVarPath = `/bo/v1/customers/{customer-id}/cards/{card-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeCardPatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRoleOrSalesRoleAndAllowed(#patch.changesOnlyProducts() || #patch.changesOnlyChannel())
         * @param {string} customerId 
         * @param {BackOfficeCustomerPatchDtoV2} backOfficeCustomerPatchDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomer: async (customerId: string, backOfficeCustomerPatchDtoV2: BackOfficeCustomerPatchDtoV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchCustomer', 'customerId', customerId)
            // verify required parameter 'backOfficeCustomerPatchDtoV2' is not null or undefined
            assertParamExists('patchCustomer', 'backOfficeCustomerPatchDtoV2', backOfficeCustomerPatchDtoV2)
            const localVarPath = `/bo/v2/customers/{customer-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficeCustomerPatchDtoV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFeatureOverridePatch} billingSettingsFeatureOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFeatureOverrides: async (customerId: string, billingSettingsFeatureOverridePatch: BillingSettingsFeatureOverridePatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchFeatureOverrides', 'customerId', customerId)
            // verify required parameter 'billingSettingsFeatureOverridePatch' is not null or undefined
            assertParamExists('patchFeatureOverrides', 'billingSettingsFeatureOverridePatch', billingSettingsFeatureOverridePatch)
            const localVarPath = `/bo/v1/customers/{customer-id}/billing-settings/overrides/features`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billingSettingsFeatureOverridePatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackofficeInvoicingConfigPatchDto} backofficeInvoicingConfigPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInvoicingConfigV1: async (customerId: string, backofficeInvoicingConfigPatchDto: BackofficeInvoicingConfigPatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchInvoicingConfigV1', 'customerId', customerId)
            // verify required parameter 'backofficeInvoicingConfigPatchDto' is not null or undefined
            assertParamExists('patchInvoicingConfigV1', 'backofficeInvoicingConfigPatchDto', backofficeInvoicingConfigPatchDto)
            const localVarPath = `/bo/v1/customers/{customer-id}/invoicing-config`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backofficeInvoicingConfigPatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsOverridePatch} billingSettingsOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOverrides: async (customerId: string, billingSettingsOverridePatch: BillingSettingsOverridePatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchOverrides', 'customerId', customerId)
            // verify required parameter 'billingSettingsOverridePatch' is not null or undefined
            assertParamExists('patchOverrides', 'billingSettingsOverridePatch', billingSettingsOverridePatch)
            const localVarPath = `/bo/v1/customers/{customer-id}/billing-settings/overrides`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billingSettingsOverridePatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {BackOfficePatchPaymentRequestDto} backOfficePatchPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPayment: async (paymentId: string, backOfficePatchPaymentRequestDto: BackOfficePatchPaymentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('patchPayment', 'paymentId', paymentId)
            // verify required parameter 'backOfficePatchPaymentRequestDto' is not null or undefined
            assertParamExists('patchPayment', 'backOfficePatchPaymentRequestDto', backOfficePatchPaymentRequestDto)
            const localVarPath = `/bo/payments/{payment-id}`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficePatchPaymentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {PatchPaymentRequestDtoV2} patchPaymentRequestDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentRequestV2: async (paymentRequestId: string, patchPaymentRequestDtoV2: PatchPaymentRequestDtoV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('patchPaymentRequestV2', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'patchPaymentRequestDtoV2' is not null or undefined
            assertParamExists('patchPaymentRequestV2', 'patchPaymentRequestDtoV2', patchPaymentRequestDtoV2)
            const localVarPath = `/bo/v2/payment-request/{payment-request-id}`
                .replace(`{${"payment-request-id"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchPaymentRequestDtoV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {PatchV3ResourceBody} patchV3ResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRawAccountV3: async (customerId: string, accountId: string, patchV3ResourceBody: PatchV3ResourceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchRawAccountV3', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('patchRawAccountV3', 'accountId', accountId)
            // verify required parameter 'patchV3ResourceBody' is not null or undefined
            assertParamExists('patchRawAccountV3', 'patchV3ResourceBody', patchV3ResourceBody)
            const localVarPath = `/bo/customers/{customer-id}/card/raw/accounts/v3/{account-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchV3ResourceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {PatchPrepaidResourceBody} patchPrepaidResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRawAccountV4: async (customerId: string, accountId: string, patchPrepaidResourceBody: PatchPrepaidResourceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchRawAccountV4', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('patchRawAccountV4', 'accountId', accountId)
            // verify required parameter 'patchPrepaidResourceBody' is not null or undefined
            assertParamExists('patchRawAccountV4', 'patchPrepaidResourceBody', patchPrepaidResourceBody)
            const localVarPath = `/bo/customers/{customer-id}/card/raw/accounts/v4/{account-id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchPrepaidResourceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsTrialOverridePatch} billingSettingsTrialOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTrialOverrides: async (customerId: string, billingSettingsTrialOverridePatch: BillingSettingsTrialOverridePatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('patchTrialOverrides', 'customerId', customerId)
            // verify required parameter 'billingSettingsTrialOverridePatch' is not null or undefined
            assertParamExists('patchTrialOverrides', 'billingSettingsTrialOverridePatch', billingSettingsTrialOverridePatch)
            const localVarPath = `/bo/v1/customers/{customer-id}/billing-settings/overrides/trials`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billingSettingsTrialOverridePatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        person: async (id: string, personId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('person', 'id', id)
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('person', 'personId', personId)
            const localVarPath = `/bo/customers/{id}/persons/{person-id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"person-id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRecalculateV2: async (paymentRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('postRecalculateV2', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/bo/v2/payment-request/{payment-request-id}/recalculate`
                .replace(`{${"payment-request-id"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (id: string, body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('put', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('put', 'body', body)
            const localVarPath = `/bo/sms-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put1: async (customerId: string, id: string, body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('put1', 'customerId', customerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('put1', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('put1', 'body', body)
            const localVarPath = `/bo/customers/{customerId}/notes/{id}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole() Idempotent write of a projected credit application row. Rows with a projectedAt older than or equal to the stored row are ignored.
         * @param {string} requestId 
         * @param {BackofficeCreditApplicationV1Dto} backofficeCreditApplicationV1Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCreditApplication: async (requestId: string, backofficeCreditApplicationV1Dto: BackofficeCreditApplicationV1Dto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('putCreditApplication', 'requestId', requestId)
            // verify required parameter 'backofficeCreditApplicationV1Dto' is not null or undefined
            assertParamExists('putCreditApplication', 'backofficeCreditApplicationV1Dto', backofficeCreditApplicationV1Dto)
            const localVarPath = `/bo/v1/credit-applications/{request-id}`
                .replace(`{${"request-id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backofficeCreditApplicationV1Dto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} submissionId 
         * @param {BackOfficePaymentDeclarationDecisionRequestV1Dto} backOfficePaymentDeclarationDecisionRequestV1Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordDecision: async (submissionId: string, backOfficePaymentDeclarationDecisionRequestV1Dto: BackOfficePaymentDeclarationDecisionRequestV1Dto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('recordDecision', 'submissionId', submissionId)
            // verify required parameter 'backOfficePaymentDeclarationDecisionRequestV1Dto' is not null or undefined
            assertParamExists('recordDecision', 'backOfficePaymentDeclarationDecisionRequestV1Dto', backOfficePaymentDeclarationDecisionRequestV1Dto)
            const localVarPath = `/bo/v1/payment-declarations/{submission-id}/decisions`
                .replace(`{${"submission-id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backOfficePaymentDeclarationDecisionRequestV1Dto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAddress: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('refreshAddress', 'customerId', customerId)
            const localVarPath = `/bo/v2/customers/{customer-id}/refresh-address`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueCard: async (customerId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('reissueCard', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('reissueCard', 'cardId', cardId)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}/update/REISSUE_CARD`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {DeleteAuthPersonDto} deleteAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAuthPerson: async (deleteAuthPersonDto: DeleteAuthPersonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAuthPersonDto' is not null or undefined
            assertParamExists('removeAuthPerson', 'deleteAuthPersonDto', deleteAuthPersonDto)
            const localVarPath = `/bo/authperson/migrate/delete-auth-person`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAuthPersonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} country 
         * @param {string} regNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCompanyFromPortfolio: async (portfolioId: string, country: string, regNo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('removeCompanyFromPortfolio', 'portfolioId', portfolioId)
            // verify required parameter 'country' is not null or undefined
            assertParamExists('removeCompanyFromPortfolio', 'country', country)
            // verify required parameter 'regNo' is not null or undefined
            assertParamExists('removeCompanyFromPortfolio', 'regNo', regNo)
            const localVarPath = `/bo/credit-risk/monitoring/{portfolioId}/companies/{country}/{regNo}`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)))
                .replace(`{${"country"}}`, encodeURIComponent(String(country)))
                .replace(`{${"regNo"}}`, encodeURIComponent(String(regNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {DeleteAuthPersonDto} deleteAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmailAuthPerson: async (deleteAuthPersonDto: DeleteAuthPersonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAuthPersonDto' is not null or undefined
            assertParamExists('removeEmailAuthPerson', 'deleteAuthPersonDto', deleteAuthPersonDto)
            const localVarPath = `/bo/authperson/migrate/disconnect-email-auth-person`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAuthPersonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendDirectDebitMandateV4: async (customerId: string, mandateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('resendDirectDebitMandateV4', 'customerId', customerId)
            // verify required parameter 'mandateId' is not null or undefined
            assertParamExists('resendDirectDebitMandateV4', 'mandateId', mandateId)
            const localVarPath = `/bo/v4/customers/{customer-id}/direct-debit-mandates/{mandate-id}/resend`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"mandate-id"}}`, encodeURIComponent(String(mandateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetBureau: async (resetRequest: ResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetRequest' is not null or undefined
            assertParamExists('resetBureau', 'resetRequest', resetRequest)
            const localVarPath = `/bo/v1/bureau/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPinAttempt: async (customerId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('resetPinAttempt', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('resetPinAttempt', 'cardId', cardId)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}/update/RESET_PIN_ATTEMPT`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetRulesToDefault: async (portfolioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('resetRulesToDefault', 'portfolioId', portfolioId)
            const localVarPath = `/bo/credit-risk/monitoring/rules/portfolio/{portfolioId}/reset`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAlarm: async (alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alarmId' is not null or undefined
            assertParamExists('resolveAlarm', 'alarmId', alarmId)
            // verify required parameter 'resolveAlarmRequestDto' is not null or undefined
            assertParamExists('resolveAlarm', 'resolveAlarmRequestDto', resolveAlarmRequestDto)
            const localVarPath = `/bo/credit-risk/alarms/{alarmId}/resolve`
                .replace(`{${"alarmId"}}`, encodeURIComponent(String(alarmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveAlarmRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} amlCheckId 
         * @param {AmlCheckResolutionRequest} amlCheckResolutionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAmlCheck: async (amlCheckId: string, amlCheckResolutionRequest: AmlCheckResolutionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'amlCheckId' is not null or undefined
            assertParamExists('resolveAmlCheck', 'amlCheckId', amlCheckId)
            // verify required parameter 'amlCheckResolutionRequest' is not null or undefined
            assertParamExists('resolveAmlCheck', 'amlCheckResolutionRequest', amlCheckResolutionRequest)
            const localVarPath = `/bo/v2/aml-payment-requests/{aml-check-id}/resolve`
                .replace(`{${"aml-check-id"}}`, encodeURIComponent(String(amlCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(amlCheckResolutionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasRole(\'BACKOFFICE_SALES\')
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRoleChecker: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} q 
         * @param {number} [n] 
         * @param {string} [t] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (q: string, n?: number, t?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('search', 'q', q)
            const localVarPath = `/bo/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (n !== undefined) {
                localVarQueryParameter['n'] = n;
            }

            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} [search] 
         * @param {string} [customerId] 
         * @param {Array<string>} [country] 
         * @param {Array<string>} [partner] 
         * @param {Array<string>} [kycStatus] 
         * @param {Array<RequestStatus>} [requestStatus] 
         * @param {Array<PendingReason>} [pendingReason] 
         * @param {boolean} [hasPendingReasons] 
         * @param {Array<AgreementStatus>} [agreementStatus] 
         * @param {boolean} [snoozed] 
         * @param {Field} [sortBy] 
         * @param {Direction} [sortDirection] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCreditApplications: async (search?: string, customerId?: string, country?: Array<string>, partner?: Array<string>, kycStatus?: Array<string>, requestStatus?: Array<RequestStatus>, pendingReason?: Array<PendingReason>, hasPendingReasons?: boolean, agreementStatus?: Array<AgreementStatus>, snoozed?: boolean, sortBy?: Field, sortDirection?: Direction, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/credit-applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (country) {
                localVarQueryParameter['country'] = Array.from(country);
            }

            if (partner) {
                localVarQueryParameter['partner'] = Array.from(partner);
            }

            if (kycStatus) {
                localVarQueryParameter['kycStatus'] = Array.from(kycStatus);
            }

            if (requestStatus) {
                localVarQueryParameter['requestStatus'] = Array.from(requestStatus);
            }

            if (pendingReason) {
                localVarQueryParameter['pendingReason'] = Array.from(pendingReason);
            }

            if (hasPendingReasons !== undefined) {
                localVarQueryParameter['hasPendingReasons'] = hasPendingReasons;
            }

            if (agreementStatus) {
                localVarQueryParameter['agreementStatus'] = Array.from(agreementStatus);
            }

            if (snoozed !== undefined) {
                localVarQueryParameter['snoozed'] = snoozed;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/search/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddBankDataRequestDto} addBankDataRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddBankDataEmail: async (addBankDataRequestDto: AddBankDataRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addBankDataRequestDto' is not null or undefined
            assertParamExists('sendAddBankDataEmail', 'addBankDataRequestDto', addBankDataRequestDto)
            const localVarPath = `/bo/bank-data/send-add-bank-data-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addBankDataRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Email agreement to all signatories
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAgreementEmailV8: async (customerId: string, agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('sendAgreementEmailV8', 'customerId', customerId)
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('sendAgreementEmailV8', 'agreementId', agreementId)
            const localVarPath = `/bo/v8/customers/{customer-id}/agreements/{agreement-id}/send-email`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"agreement-id"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Send reminder email for unsigned credit agreement
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAgreementReminderV8: async (customerId: string, agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('sendAgreementReminderV8', 'customerId', customerId)
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('sendAgreementReminderV8', 'agreementId', agreementId)
            const localVarPath = `/bo/v8/customers/{customer-id}/agreements/{agreement-id}/send-reminder`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"agreement-id"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKycExpiredEmail: async (customerId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('sendKycExpiredEmail', 'customerId', customerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendKycExpiredEmail', 'body', body)
            const localVarPath = `/bo/v2/customers/{customer-id}/send-kyc-expired-email`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {boolean} [ssnWaiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKycLinkEmail: async (customerId: string, body: string, ssnWaiver?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('sendKycLinkEmail', 'customerId', customerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendKycLinkEmail', 'body', body)
            const localVarPath = `/bo/v2/customers/{customer-id}/send-kyc-link-email`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ssnWaiver !== undefined) {
                localVarQueryParameter['ssn-waiver'] = ssnWaiver;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKycRenewalEmail: async (customerId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('sendKycRenewalEmail', 'customerId', customerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendKycRenewalEmail', 'body', body)
            const localVarPath = `/bo/v2/customers/{customer-id}/send-kyc-renewal-email`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {MonthlyReportRequest} monthlyReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMonthlyReport: async (customerId: string, monthlyReportRequest: MonthlyReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('sendMonthlyReport', 'customerId', customerId)
            // verify required parameter 'monthlyReportRequest' is not null or undefined
            assertParamExists('sendMonthlyReport', 'monthlyReportRequest', monthlyReportRequest)
            const localVarPath = `/bo/customer/{customer-id}/card/transactions/pe/monthly-reports`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(monthlyReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewBankDataSessionRequestDto} newBankDataSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewBankDataSessionEmail: async (newBankDataSessionRequestDto: NewBankDataSessionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newBankDataSessionRequestDto' is not null or undefined
            assertParamExists('sendNewBankDataSessionEmail', 'newBankDataSessionRequestDto', newBankDataSessionRequestDto)
            const localVarPath = `/bo/bank-data/send-new-bank-data-session-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newBankDataSessionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} cid 
         * @param {string} pid 
         * @param {SmsRequestDto} smsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSms: async (cid: string, pid: string, smsRequestDto: SmsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('sendSms', 'cid', cid)
            // verify required parameter 'pid' is not null or undefined
            assertParamExists('sendSms', 'pid', pid)
            // verify required parameter 'smsRequestDto' is not null or undefined
            assertParamExists('sendSms', 'smsRequestDto', smsRequestDto)
            const localVarPath = `/bo/customers/{cid}/persons/{pid}/sms`
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"pid"}}`, encodeURIComponent(String(pid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} cid 
         * @param {string} phoneNumber 
         * @param {SmsRequestDto} smsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSmsToPhoneNumber: async (cid: string, phoneNumber: string, smsRequestDto: SmsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cid' is not null or undefined
            assertParamExists('sendSmsToPhoneNumber', 'cid', cid)
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('sendSmsToPhoneNumber', 'phoneNumber', phoneNumber)
            // verify required parameter 'smsRequestDto' is not null or undefined
            assertParamExists('sendSmsToPhoneNumber', 'smsRequestDto', smsRequestDto)
            const localVarPath = `/bo/customers/{cid}/persons/phone/{phoneNumber}/sms`
                .replace(`{${"cid"}}`, encodeURIComponent(String(cid)))
                .replace(`{${"phoneNumber"}}`, encodeURIComponent(String(phoneNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestKycReminderSms: async (request: Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('sendTestKycReminderSms', 'request', request)
            const localVarPath = `/bo/test/kyc-reminder-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendWelcomeEmail: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('sendWelcomeEmail', 'customerId', customerId)
            const localVarPath = `/bo/v2/customers/{customer-id}/send-welcome-email`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonDto} updateAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAuthPersonId: async (updateAuthPersonDto: UpdateAuthPersonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAuthPersonDto' is not null or undefined
            assertParamExists('setAuthPersonId', 'updateAuthPersonDto', updateAuthPersonDto)
            const localVarPath = `/bo/authperson/migrate/update-auth-person`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAuthPersonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetIdDomainRequest} setIdDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDomainId: async (setIdDomainRequest: SetIdDomainRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setIdDomainRequest' is not null or undefined
            assertParamExists('setDomainId', 'setIdDomainRequest', setIdDomainRequest)
            const localVarPath = `/bo/authperson/set-domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setIdDomainRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCard: async (customerId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('syncCard', 'customerId', customerId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('syncCard', 'cardId', cardId)
            const localVarPath = `/bo/customers/{customer-id}/card/cards/{card-id}/sync`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDirectDebitMandateV4: async (customerId: string, mandateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('syncDirectDebitMandateV4', 'customerId', customerId)
            // verify required parameter 'mandateId' is not null or undefined
            assertParamExists('syncDirectDebitMandateV4', 'mandateId', mandateId)
            const localVarPath = `/bo/v4/customers/{customer-id}/direct-debit-mandates/{mandate-id}/sync`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"mandate-id"}}`, encodeURIComponent(String(mandateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFile: async (customerId: string, id: string, uploadRequest: UploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('syncFile', 'customerId', customerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('syncFile', 'id', id)
            // verify required parameter 'uploadRequest' is not null or undefined
            assertParamExists('syncFile', 'uploadRequest', uploadRequest)
            const localVarPath = `/bo/customers/{customer-id}/files/{id}`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPortfolio: async (portfolioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('syncPortfolio', 'portfolioId', portfolioId)
            const localVarPath = `/bo/credit-risk/monitoring/{portfolioId}/sync`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Get a list of transaction conditions from Enfuce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionConditions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/transaction-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Trigger expense checker outcome migration
         * @param {boolean} [realRun] 
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trigger: async (realRun?: boolean, limit?: number, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/expense-checker-outcome-migration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (realRun !== undefined) {
                localVarQueryParameter['real-run'] = realRun;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerBusinessEvent: async (customerId: string, txId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('triggerBusinessEvent', 'customerId', customerId)
            // verify required parameter 'txId' is not null or undefined
            assertParamExists('triggerBusinessEvent', 'txId', txId)
            const localVarPath = `/bo/customers/{customer-id}/card/transactions/{tx-id}/trigger-business-event`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"tx-id"}}`, encodeURIComponent(String(txId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerBusinessEventV2: async (customerId: string, txId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('triggerBusinessEventV2', 'customerId', customerId)
            // verify required parameter 'txId' is not null or undefined
            assertParamExists('triggerBusinessEventV2', 'txId', txId)
            const localVarPath = `/bo/v2/customers/{customer-id}/transactions/{tx-id}/trigger-business-event`
                .replace(`{${"customer-id"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"tx-id"}}`, encodeURIComponent(String(txId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauUnassingmentRequest} bureauUnassingmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassign: async (bureauUnassingmentRequest: BureauUnassingmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bureauUnassingmentRequest' is not null or undefined
            assertParamExists('unassign', 'bureauUnassingmentRequest', bureauUnassingmentRequest)
            const localVarPath = `/bo/v1/bureau/unassign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bureauUnassingmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unauthorizedException: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/test/unauthorized`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolveAlarm: async (alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alarmId' is not null or undefined
            assertParamExists('unresolveAlarm', 'alarmId', alarmId)
            // verify required parameter 'resolveAlarmRequestDto' is not null or undefined
            assertParamExists('unresolveAlarm', 'resolveAlarmRequestDto', resolveAlarmRequestDto)
            const localVarPath = `/bo/credit-risk/alarms/{alarmId}/unresolve`
                .replace(`{${"alarmId"}}`, encodeURIComponent(String(alarmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveAlarmRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {AccountDto} accountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: async (id: string, accountDto: AccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAccount', 'id', id)
            // verify required parameter 'accountDto' is not null or undefined
            assertParamExists('updateAccount', 'accountDto', accountDto)
            const localVarPath = `/bo/accountx/accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonMailDto} updateAuthPersonMailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthPersonMail: async (updateAuthPersonMailDto: UpdateAuthPersonMailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAuthPersonMailDto' is not null or undefined
            assertParamExists('updateAuthPersonMail', 'updateAuthPersonMailDto', updateAuthPersonMailDto)
            const localVarPath = `/bo/authperson/migrate/change-auth-person-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAuthPersonMailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonPhoneDto} updateAuthPersonPhoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthPersonPhoneNumber: async (updateAuthPersonPhoneDto: UpdateAuthPersonPhoneDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAuthPersonPhoneDto' is not null or undefined
            assertParamExists('updateAuthPersonPhoneNumber', 'updateAuthPersonPhoneDto', updateAuthPersonPhoneDto)
            const localVarPath = `/bo/authperson/migrate/change-auth-person-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAuthPersonPhoneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRoleOrSalesRoleAndAllowed(#patch.onlyInvite())
         * @param {string} id 
         * @param {string} personId 
         * @param {PersonPatchDto} personPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerson: async (id: string, personId: string, personPatchDto: PersonPatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePerson', 'id', id)
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('updatePerson', 'personId', personId)
            // verify required parameter 'personPatchDto' is not null or undefined
            assertParamExists('updatePerson', 'personPatchDto', personPatchDto)
            const localVarPath = `/bo/customers/{id}/persons/{person-id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"person-id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personPatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {UpdateRuleRequest} updateRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleWithParameters: async (portfolioId: string, countryCode: string, ruleCode: string, updateRuleRequest: UpdateRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('updateRuleWithParameters', 'portfolioId', portfolioId)
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('updateRuleWithParameters', 'countryCode', countryCode)
            // verify required parameter 'ruleCode' is not null or undefined
            assertParamExists('updateRuleWithParameters', 'ruleCode', ruleCode)
            // verify required parameter 'updateRuleRequest' is not null or undefined
            assertParamExists('updateRuleWithParameters', 'updateRuleRequest', updateRuleRequest)
            const localVarPath = `/bo/credit-risk/monitoring/rules/portfolio/{portfolioId}/country/{countryCode}/rule/{ruleCode}`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)))
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)))
                .replace(`{${"ruleCode"}}`, encodeURIComponent(String(ruleCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {TextProcessorPatternPatchDto} textProcessorPatternPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTextProcessorConfiguration: async (id: string, textProcessorPatternPatchDto: TextProcessorPatternPatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTextProcessorConfiguration', 'id', id)
            // verify required parameter 'textProcessorPatternPatchDto' is not null or undefined
            assertParamExists('updateTextProcessorConfiguration', 'textProcessorPatternPatchDto', textProcessorPatternPatchDto)
            const localVarPath = `/bo/v1/text-processor/patterns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(textProcessorPatternPatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {AccountXYear} accountXYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYear: async (id: string, accountXYear: AccountXYear, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateYear', 'id', id)
            // verify required parameter 'accountXYear' is not null or undefined
            assertParamExists('updateYear', 'accountXYear', accountXYear)
            const localVarPath = `/bo/accountx/years/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountXYear, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<MonitoringPortfolioCreditSafeMapping>} monitoringPortfolioCreditSafeMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCreditsafeIdMappings: async (monitoringPortfolioCreditSafeMapping: Array<MonitoringPortfolioCreditSafeMapping>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'monitoringPortfolioCreditSafeMapping' is not null or undefined
            assertParamExists('uploadCreditsafeIdMappings', 'monitoringPortfolioCreditSafeMapping', monitoringPortfolioCreditSafeMapping)
            const localVarPath = `/bo/credit-risk/monitoring/mappings/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(monitoringPortfolioCreditSafeMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whiteListPaymentV1: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('whiteListPaymentV1', 'paymentId', paymentId)
            const localVarPath = `/bo/payments/{payment-id}/whitelist`
                .replace(`{${"payment-id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BackOfficeAPIApi - functional programming interface
 * @export
 */
export const BackOfficeAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BackOfficeAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountsBasic(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackOfficeAccountBasicDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountsBasic(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.accountsBasic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {string} plasticId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activatePlastic(customerId: string, cardId: string, plasticId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activatePlastic(customerId, cardId, plasticId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.activatePlastic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateRule(portfolioId: string, countryCode: string, ruleCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateRule(portfolioId, countryCode, ruleCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.activateRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async add(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.add(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.add']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async add1(customerId: string, body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.add1(customerId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.add1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} country 
         * @param {string} regNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCompanyToPortfolio(portfolioId: string, country: string, regNo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCompanyToPortfolio(portfolioId, country, regNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.addCompanyToPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFile(customerId: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFile(customerId, uploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.addFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} itemId 
         * @param {SnoozeDto} snoozeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSnooze(itemId: string, snoozeDto: SnoozeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnoozeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSnooze(itemId, snoozeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.addSnooze']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} validFrom 
         * @param {number} foodAndBeverageDeductionLimit 
         * @param {number} simpleFoodDeductionLimit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSwedishRepresentationVATValues(validFrom: string, foodAndBeverageDeductionLimit: number, simpleFoodDeductionLimit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSwedishRepresentationVATValues(validFrom, foodAndBeverageDeductionLimit, simpleFoodDeductionLimit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.addSwedishRepresentationVATValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async alreadyExistingException(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.alreadyExistingException(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.alreadyExistingException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauRelationshipRequest} bureauRelationshipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assign(bureauRelationshipRequest: BureauRelationshipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BureauRelationshipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assign(bureauRelationshipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.assign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backofficeRoleChecker(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backofficeRoleChecker(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.backofficeRoleChecker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PersonLoginRequest} personLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bizOpsLogin(personLoginRequest: PersonLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bizOpsLogin(personLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.bizOpsLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bureau(bureauId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BureauConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bureau(bureauId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.bureau']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bureauClients(bureauId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BureauRelationshipResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bureauClients(bureauId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.bureauClients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bureauPendingTasks(bureauId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BureauClientsPendingTaskAndAvailableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bureauPendingTasks(bureauId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.bureauPendingTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDirectDebitMandatesV4200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDirectDebitMandateV4(customerId, mandateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.cancelDirectDebitMandateV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {string} userAgent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPisDeposit(customerId: string, depositId: string, userAgent: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficePisDepositResponseV1Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPisDeposit(customerId, depositId, userAgent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.cancelPisDeposit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardDeliveryAddress(customerId: string, personId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeCardDeliveryAddressResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardDeliveryAddress(customerId, personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.cardDeliveryAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cards(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackOfficeCardsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cards(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.cards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary churn customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async churnCustomer(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.churnCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.churnCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async client(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BureauRelationshipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.client(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.client']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauConfigRequest} bureauConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configure(bureauConfigRequest: BureauConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BureauConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configure(bureauConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.configure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} [search] 
         * @param {string} [customerId] 
         * @param {Array<string>} [country] 
         * @param {Array<string>} [partner] 
         * @param {Array<string>} [kycStatus] 
         * @param {Array<RequestStatus>} [requestStatus] 
         * @param {Array<PendingReason>} [pendingReason] 
         * @param {boolean} [hasPendingReasons] 
         * @param {Array<AgreementStatus>} [agreementStatus] 
         * @param {boolean} [snoozed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countCreditApplications(search?: string, customerId?: string, country?: Array<string>, partner?: Array<string>, kycStatus?: Array<string>, requestStatus?: Array<RequestStatus>, pendingReason?: Array<PendingReason>, hasPendingReasons?: boolean, agreementStatus?: Array<AgreementStatus>, snoozed?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeCreditApplicationCountV1Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countCreditApplications(search, customerId, country, partner, kycStatus, requestStatus, pendingReason, hasPendingReasons, agreementStatus, snoozed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.countCreditApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {AccountDto} accountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(accountDto: AccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(accountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Create a new Agreement with status draft
         * @param {string} customerId 
         * @param {BackOfficeAgreementCreationDtoV8} backOfficeAgreementCreationDtoV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgreementV8(customerId: string, backOfficeAgreementCreationDtoV8: BackOfficeAgreementCreationDtoV8, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllAgreementsV8200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgreementV8(customerId, backOfficeAgreementCreationDtoV8, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createAgreementV8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreateAuthPersonForEmailDto} createAuthPersonForEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAuthPersonForEmail(createAuthPersonForEmailDto: CreateAuthPersonForEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAuthPersonForEmail(createAuthPersonForEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createAuthPersonForEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary create a new customer entity
         * @param {BackOfficeCustomerCreateDtoV2} backOfficeCustomerCreateDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomer(backOfficeCustomerCreateDtoV2: BackOfficeCustomerCreateDtoV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeCustomerDtoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomer(backOfficeCustomerCreateDtoV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {CreateDirectDebitMandateV4Request} createDirectDebitMandateV4Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDirectDebitMandateV4(customerId: string, createDirectDebitMandateV4Request: CreateDirectDebitMandateV4Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDirectDebitMandatesV4200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDirectDebitMandateV4(customerId, createDirectDebitMandateV4Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createDirectDebitMandateV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreatePasswordRequestDto} createPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPasswords(createPasswordRequestDto: CreatePasswordRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPasswords(createPasswordRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createPasswords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BackOfficeCreatePaymentForCustomerRequestDto} backOfficeCreatePaymentForCustomerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPayment(backOfficeCreatePaymentForCustomerRequestDto: BackOfficeCreatePaymentForCustomerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficePaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPayment(backOfficeCreatePaymentForCustomerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {CreatePersonDto} createPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPersonWithRoles(id: string, createPersonDto: CreatePersonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPersonWithRoles(id, createPersonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createPersonWithRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePortfolioRequest} createPortfolioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPortfolio(createPortfolioRequest: CreatePortfolioRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPortfolio(createPortfolioRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Create new signatories data
         * @param {string} customerId 
         * @param {Array<BackOfficeSignatoryDto>} backOfficeSignatoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSignatories(customerId: string, backOfficeSignatoryDto: Array<BackOfficeSignatoryDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeSignatoryInfoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSignatories(customerId, backOfficeSignatoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createSignatories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreatePaymentRequestDtoV2} createPaymentRequestDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createV2(createPaymentRequestDtoV2: CreatePaymentRequestDtoV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentRequestDtoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createV2(createPaymentRequestDtoV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {VoucherDto} voucherDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVoucher(voucherDto: VoucherDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoucherDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVoucher(voucherDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createVoucher']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {AccountXYear} accountXYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createYear(accountXYear: AccountXYear, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountXYear>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createYear(accountXYear, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.createYear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateRule(portfolioId: string, countryCode: string, ruleCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateRule(portfolioId, countryCode, ruleCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deactivateRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete1(customerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete1(customerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.delete1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {PersonsToDeleteAuthPersonIds} personsToDeleteAuthPersonIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAuthPerson(personsToDeleteAuthPersonIds: PersonsToDeleteAuthPersonIds, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAuthPerson(personsToDeleteAuthPersonIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteAuthPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomer(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} authpersonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExistingAuthPerson(authpersonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExistingAuthPerson(authpersonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteExistingAuthPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFeatureName} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFeatureOverride(customerId: string, featureName: BillingSettingsFeatureName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFeatureOverride(customerId, featureName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteFeatureOverride']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(customerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilexDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(customerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFieldName} fieldName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOverrides(customerId: string, fieldName: BillingSettingsFieldName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOverrides(customerId, fieldName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteOverrides']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} paymentWhiteListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaymentWhiteListV1(customerId: string, paymentWhiteListId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaymentWhiteListV1(customerId, paymentWhiteListId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deletePaymentWhiteListV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePerson(id: string, personId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePerson(id, personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deletePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePreorderCardV1(customerId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePreorderCardV1(customerId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deletePreorderCardV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSnooze(itemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSnooze(itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteSnooze']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTextProcessorConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTextProcessorConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteTextProcessorConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteYear(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteYear(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.deleteYear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async directLoginToken(id: string, personId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.directLoginToken(id, personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.directLoginToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FetchRequestDto} fetchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetch(fetchRequestDto: FetchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetch(fetchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.fetch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAndSaveNotifications(fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAndSaveNotifications(fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.fetchAndSaveNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SmsTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.findAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBy(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBy(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.findBy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary List audit logs
         * @param {string} [customerId] 
         * @param {string} [resourceId] 
         * @param {Array<string>} [hierarchyElement] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByCustomerId(customerId?: string, resourceId?: string, hierarchyElement?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditLogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByCustomerId(customerId, resourceId, hierarchyElement, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.findByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary fetch a customer entity by id
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCustomerById(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeCustomerDtoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCustomerById(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.findCustomerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEInvoiceAddresses(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EInvoiceAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEInvoiceAddresses(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.findEInvoiceAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forbiddenException(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forbiddenException(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.forbiddenException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalException(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalException(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.generalException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get1(customerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get1(customerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.get1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getAccount(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepaidAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getAccount3(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount3(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAccount3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get an accounts balance, available, and creditlimit. This requires a downstream call to enfuce.
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountStatusV5(customerId: string, accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeAccountStatusV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountStatusV5(customerId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAccountStatusV5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountV2(customerId: string, accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeAccountGetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountV2(customerId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAccountV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get an account on customer
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountV5(customerId: string, accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountsV5200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountV5(customerId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAccountV5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccounts(year?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccounts(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountsV2(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackOfficeAccountGetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountsV2(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAccountsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get a list of all accounts on customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountsV5(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAccountsV5200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountsV5(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAccountsV5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivationGuide(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivationGuideDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivationGuide(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getActivationGuide']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivationGuideVisibility(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivationGuideDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivationGuideVisibility(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getActivationGuideVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveAlarms(pageNumber?: number, pageSize?: number, sortDirection?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAlarmsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveAlarms(pageNumber, pageSize, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getActiveAlarms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveSessions(pageSize?: number, pageNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveSessionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveSessions(pageSize, pageNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getActiveSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Get agreement details for given agreement-id
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreementV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllAgreementsV8200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreementV8(customerId, agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAgreementV8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlarmById(alarmId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlarmItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlarmById(alarmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAlarmById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlarmsByCustomerId(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlarmWithLogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlarmsByCustomerId(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAlarmsByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get a list of all agreements on customer
         * @param {string} customerId 
         * @param {Array<BackOfficeAgreementTypeV8>} [agreementType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAgreementsV8(customerId: string, agreementType?: Array<BackOfficeAgreementTypeV8>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAllAgreementsV8200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAgreementsV8(customerId, agreementType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAllAgreementsV8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [status] 
         * @param {string} [companyName] 
         * @param {string} [sortDirection] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAlarms(pageNumber?: number, pageSize?: number, status?: string, companyName?: string, sortDirection?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAlarmsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAlarms(pageNumber, pageSize, status, companyName, sortDirection, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAllAlarms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContexts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContexts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAllContexts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEventRules(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyChangeRule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEventRules(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAllEventRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMonthlyReports(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MonthlyReportLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMonthlyReports(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAllMonthlyReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNotificationEvents(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyChange>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllNotificationEvents(fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAllNotificationEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTextProcessorConfigurations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TextProcessorPatternDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTextProcessorConfigurations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAllTextProcessorConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [years] 
         * @param {Array<number>} [accounts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllVouchers(from?: string, to?: string, years?: Array<string>, accounts?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoucherDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllVouchers(from, to, years, accounts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAllVouchers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authpersonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthPersonInfo(authpersonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthPersonInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthPersonInfo(authpersonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getAuthPersonInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Offset, start transaction list at this offset. Limit is how many transactions to return. transactionDate do not have a timezone
         * @param {string} customerId 
         * @param {number} [offset] pagination offset
         * @param {number} [limit] pagination limit
         * @param {string} [from] from date (inclusive) in ISO format, yyyy-MM-dd
         * @param {string} [to] to date (inclusive) in ISO format, yyyy-MM-dd
         * @param {number} [min] min transaction amount (inclusive)
         * @param {number} [max] max transaction amount (inclusive)
         * @param {Array<TransactionFilters>} [onlyinclude] various transaction property filters, some are mutually exclusive
         * @param {Array<TransactionFilters>} [exclude] 
         * @param {Array<AttestStatus>} [attestStatus] 
         * @param {string} [query] Free text query search. At least 3 characters, otherwise ignored
         * @param {Array<string>} [personIds] \&#39;or-ed\&#39; person id\&#39;s to query for, if omitted then transactions for all users will be returned. note: returned set increases with with more personIds and decreases with less personId, except for the empty set which returns all transactions
         * @param {Array<string>} [cardIds] 
         * @param {Array<BackOfficeTx2StatusFilter2>} [status] Filter on transaction status. Leave empty to include all statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoTransactionsV2(customerId: string, offset?: number, limit?: number, from?: string, to?: string, min?: number, max?: number, onlyinclude?: Array<TransactionFilters>, exclude?: Array<TransactionFilters>, attestStatus?: Array<AttestStatus>, query?: string, personIds?: Array<string>, cardIds?: Array<string>, status?: Array<BackOfficeTx2StatusFilter2>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBoTransactionsV2DefaultResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoTransactionsV2(customerId, offset, limit, from, to, min, max, onlyinclude, exclude, attestStatus, query, personIds, cardIds, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getBoTransactionsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCustomerId(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankDataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCustomerId(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisaCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCard(customerId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardBalanceConfig(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardBalanceConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardBalanceConfig(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCardBalanceConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardConfig(customerId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardConfig(customerId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCardConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardCreditV2(customerId: string, creditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeCardCreditGetV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardCreditV2(customerId, creditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCardCreditV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardCreditsV2(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackOfficeCardCreditGetV2Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardCreditsV2(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCardCreditsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardPlastics(customerId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListPlasticResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardPlastics(customerId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCardPlastics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardV1(customerId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardV1(customerId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCardV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCards(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VisaCardListResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCards(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCorporateCustomer(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCorporateCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCorporateCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCreditApplication(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeCreditApplicationV1Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCreditApplication(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getCreditApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectDebitMandatesV4(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDirectDebitMandatesV4200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectDebitMandatesV4(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getDirectDebitMandatesV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventRulesByCountry(countryCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyChangeRule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventRulesByCountry(countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getEventRulesByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventRulesForPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyChangeRule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventRulesForPortfolio(portfolioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getEventRulesForPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventRulesForPortfolioAndCountry(portfolioId: string, countryCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyChangeRule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventRulesForPortfolioAndCountry(portfolioId, countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getEventRulesForPortfolioAndCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {Array<string>} [contexts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiles(customerId: string, contexts?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilexDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiles(customerId, contexts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGermanyDistrictCourtCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeDistrictCourtDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGermanyDistrictCourtCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getGermanyDistrictCourtCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Array<InboxItemType>} [types] Filter for specific types. Accepts a comma separated list. If omitted, all types are returned
         * @param {boolean} [snoozed] should snoozed items be included or not
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getInbox(types?: Array<InboxItemType>, snoozed?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InboxItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInbox(types, snoozed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getInbox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicingConfigV1(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeInvoicingConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicingConfigV1(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getInvoicingConfigV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestSession(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LatestSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestSession(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getLatestSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartners(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartners(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPartners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayment(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficePaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayment(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentDeclaration(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficePaymentDeclarationV1Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentDeclaration(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPaymentDeclaration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentReceiverV1(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeReceiverInformationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentReceiverV1(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPaymentReceiverV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestV2(paymentRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentRequestDtoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestV2(paymentRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPaymentRequestV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [customerId] 
         * @param {string} [cardCreditId] 
         * @param {Array<string>} [currency] 
         * @param {boolean} [hasPaidEnough] 
         * @param {Array<PaymentRequestStatusDtoV2>} [status] 
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {string} [paymentRequestDateFrom] 
         * @param {string} [paymentRequestDateTo] 
         * @param {string} [periodFrom] 
         * @param {string} [periodTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestsV2(customerId?: string, cardCreditId?: string, currency?: Array<string>, hasPaidEnough?: boolean, status?: Array<PaymentRequestStatusDtoV2>, dueDateFrom?: string, dueDateTo?: string, paymentRequestDateFrom?: string, paymentRequestDateTo?: string, periodFrom?: string, periodTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentRequestDtoV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestsV2(customerId, cardCreditId, currency, hasPaidEnough, status, dueDateFrom, dueDateTo, paymentRequestDateFrom, paymentRequestDateTo, periodFrom, periodTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPaymentRequestsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentWhiteListV1(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackOfficePaymentWhiteListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentWhiteListV1(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPaymentWhiteListV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Array<PaymentState>} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayments(state?: Array<PaymentState>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackOfficePaymentResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayments(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayoutRequest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayoutRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPayoutRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdfV2(paymentRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentRequestPdfDtoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdfV2(paymentRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPdfV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonsWithRoles(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PersonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonsWithRoles(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPersonsWithRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreSignedUrl(customerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreSignedUrl(customerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPreSignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferredDirectDebitMandateV4(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDirectDebitMandatesV4200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferredDirectDebitMandateV4(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPreferredDirectDebitMandateV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivateCustomers(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrivateCustomerResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivateCustomers(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getPrivateCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRawAccountV3(customerId: string, accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountV3Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRawAccountV3(customerId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getRawAccountV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRawAccountV4(customerId: string, accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepaidAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRawAccountV4(customerId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getRawAccountV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRawAccountsV3(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListV3AccountResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRawAccountsV3(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getRawAccountsV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRawAccountsV4(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListPrepaidAccountResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRawAccountsV4(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getRawAccountsV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgNo 
         * @param {string} country 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSavedNotifications(orgNo: string, country: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyChange>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSavedNotifications(orgNo, country, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getSavedNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get signatories data
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSignatories(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeSignatoryInfoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSignatories(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getSignatories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransaction(customerId: string, txId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransaction(customerId, txId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary offset takes precedence over page if provided. Page is still available for backward compatibility. limit defaults to 20
         * @param {string} customerId 
         * @param {number} [page] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsCombined(customerId: string, page?: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsCombined(customerId, page, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getTransactionsCombined']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpgradeOption(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionPlanUpgradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpgradeOption(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getUpgradeOption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [years] 
         * @param {Array<number>} [accounts] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVouchersResultReport(from?: string, to?: string, years?: Array<string>, accounts?: Array<number>, currency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountResultDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVouchersResultReport(from, to, years, accounts, currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getVouchersResultReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYears(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountXYear>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYears(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.getYears']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleOAuthRedir(callback: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleOAuthRedir(callback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.googleOAuthRedir']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async illegalArgumentException(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.illegalArgumentException(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.illegalArgumentException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async illegalStateException(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.illegalStateException(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.illegalStateException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {string} userAgent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectPisDeposit(customerId: string, depositId: string, userAgent: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficePisDepositResponseV1Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectPisDeposit(customerId, depositId, userAgent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.inspectPisDeposit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isLoggedIn(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeGoogleAuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isLoggedIn(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.isLoggedIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kycApproved(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kycApproved(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.kycApproved']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackOfficeCustomerKycRequiresRenewalDtoV2} backOfficeCustomerKycRequiresRenewalDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kycRequiresRenewal(customerId: string, backOfficeCustomerKycRequiresRenewalDtoV2: BackOfficeCustomerKycRequiresRenewalDtoV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kycRequiresRenewal(customerId, backOfficeCustomerKycRequiresRenewalDtoV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.kycRequiresRenewal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BureauConfigResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} [searchQuery] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCompaniesInPortfolio(portfolioId: string, searchQuery?: string, pageSize?: number, page?: number, countryCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCompaniesInPortfolio(portfolioId, searchQuery, pageSize, page, countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.listCompaniesInPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPisDepositEvents(customerId: string, depositId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackofficePisDepositEventResponseV1Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPisDepositEvents(customerId, depositId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.listPisDepositEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPisDeposits(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackofficePisDepositResponseV1Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPisDeposits(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.listPisDeposits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPortfolios(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Portfolio>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPortfolios(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.listPortfolios']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async log(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.log(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.log']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAlarmUnderReview(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAlarmUnderReview(alarmId, resolveAlarmRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.markAlarmUnderReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateAuth0Users(requestDto: RequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateAuth0Users(requestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.migrateAuth0Users']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notFoundException(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notFoundException(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.notFoundException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyCardCreditDenied(customerId: string, creditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyCardCreditDenied(customerId, creditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.notifyCardCreditDenied']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyCardCreditRaiseDenied(customerId: string, creditId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyCardCreditRaiseDenied(customerId, creditId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.notifyCardCreditRaiseDenied']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackOfficeOrderCardRequestDtoV3} backOfficeOrderCardRequestDtoV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderCardV3(customerId: string, backOfficeOrderCardRequestDtoV3: BackOfficeOrderCardRequestDtoV3, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderCardV3(customerId, backOfficeOrderCardRequestDtoV3, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.orderCardV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {PatchPrepaidResourceBody} patchPrepaidResourceBody 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async patchAccount(customerId: string, patchPrepaidResourceBody: PatchPrepaidResourceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAccount(customerId, patchPrepaidResourceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {BackOfficeAccountPatchDto} backOfficeAccountPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAccountV2(customerId: string, accountId: string, backOfficeAccountPatchDto: BackOfficeAccountPatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeAccountGetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAccountV2(customerId, accountId, backOfficeAccountPatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchAccountV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {ActivationGuidePatchDto} activationGuidePatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchActivationGuideVisibility(customerId: string, activationGuidePatchDto: ActivationGuidePatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivationGuideDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchActivationGuideVisibility(customerId, activationGuidePatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchActivationGuideVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {ActivationGuidePatchDto} activationGuidePatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchActivationGuideVisibility1(customerId: string, activationGuidePatchDto: ActivationGuidePatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivationGuideDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchActivationGuideVisibility1(customerId, activationGuidePatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchActivationGuideVisibility1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {PatchStandardResourceBody} patchStandardResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCard(customerId: string, cardId: string, patchStandardResourceBody: PatchStandardResourceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCard(customerId, cardId, patchStandardResourceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {CardBalanceConfigPatchDto} cardBalanceConfigPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCardBalanceConfig(customerId: string, cardBalanceConfigPatchDto: CardBalanceConfigPatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardBalanceConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCardBalanceConfig(customerId, cardBalanceConfigPatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchCardBalanceConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {CardConfigPatchRequestDto} cardConfigPatchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCardConfig(customerId: string, cardId: string, cardConfigPatchRequestDto: CardConfigPatchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCardConfig(customerId, cardId, cardConfigPatchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchCardConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {BackOfficeCardCreditPatchV2Dto} backOfficeCardCreditPatchV2Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCardCreditV2(customerId: string, creditId: string, backOfficeCardCreditPatchV2Dto: BackOfficeCardCreditPatchV2Dto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeCardCreditGetV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCardCreditV2(customerId, creditId, backOfficeCardCreditPatchV2Dto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchCardCreditV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {BackOfficeCardPatchDto} backOfficeCardPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCardV1(customerId: string, cardId: string, backOfficeCardPatchDto: BackOfficeCardPatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCardV1(customerId, cardId, backOfficeCardPatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchCardV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRoleOrSalesRoleAndAllowed(#patch.changesOnlyProducts() || #patch.changesOnlyChannel())
         * @param {string} customerId 
         * @param {BackOfficeCustomerPatchDtoV2} backOfficeCustomerPatchDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCustomer(customerId: string, backOfficeCustomerPatchDtoV2: BackOfficeCustomerPatchDtoV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficeCustomerDtoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCustomer(customerId, backOfficeCustomerPatchDtoV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFeatureOverridePatch} billingSettingsFeatureOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchFeatureOverrides(customerId: string, billingSettingsFeatureOverridePatch: BillingSettingsFeatureOverridePatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchFeatureOverrides(customerId, billingSettingsFeatureOverridePatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchFeatureOverrides']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackofficeInvoicingConfigPatchDto} backofficeInvoicingConfigPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchInvoicingConfigV1(customerId: string, backofficeInvoicingConfigPatchDto: BackofficeInvoicingConfigPatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeInvoicingConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchInvoicingConfigV1(customerId, backofficeInvoicingConfigPatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchInvoicingConfigV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsOverridePatch} billingSettingsOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchOverrides(customerId: string, billingSettingsOverridePatch: BillingSettingsOverridePatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchOverrides(customerId, billingSettingsOverridePatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchOverrides']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {BackOfficePatchPaymentRequestDto} backOfficePatchPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPayment(paymentId: string, backOfficePatchPaymentRequestDto: BackOfficePatchPaymentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficePaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPayment(paymentId, backOfficePatchPaymentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {PatchPaymentRequestDtoV2} patchPaymentRequestDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPaymentRequestV2(paymentRequestId: string, patchPaymentRequestDtoV2: PatchPaymentRequestDtoV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentRequestDtoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPaymentRequestV2(paymentRequestId, patchPaymentRequestDtoV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchPaymentRequestV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {PatchV3ResourceBody} patchV3ResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchRawAccountV3(customerId: string, accountId: string, patchV3ResourceBody: PatchV3ResourceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchRawAccountV3(customerId, accountId, patchV3ResourceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchRawAccountV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {PatchPrepaidResourceBody} patchPrepaidResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchRawAccountV4(customerId: string, accountId: string, patchPrepaidResourceBody: PatchPrepaidResourceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchRawAccountV4(customerId, accountId, patchPrepaidResourceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchRawAccountV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsTrialOverridePatch} billingSettingsTrialOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTrialOverrides(customerId: string, billingSettingsTrialOverridePatch: BillingSettingsTrialOverridePatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTrialOverrides(customerId, billingSettingsTrialOverridePatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.patchTrialOverrides']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async person(id: string, personId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.person(id, personId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.person']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRecalculateV2(paymentRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentRequestDtoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRecalculateV2(paymentRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.postRecalculateV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(id: string, body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put1(customerId: string, id: string, body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put1(customerId, id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.put1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole() Idempotent write of a projected credit application row. Rows with a projectedAt older than or equal to the stored row are ignored.
         * @param {string} requestId 
         * @param {BackofficeCreditApplicationV1Dto} backofficeCreditApplicationV1Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCreditApplication(requestId: string, backofficeCreditApplicationV1Dto: BackofficeCreditApplicationV1Dto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeCreditApplicationProjectionResultV1Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCreditApplication(requestId, backofficeCreditApplicationV1Dto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.putCreditApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} submissionId 
         * @param {BackOfficePaymentDeclarationDecisionRequestV1Dto} backOfficePaymentDeclarationDecisionRequestV1Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordDecision(submissionId: string, backOfficePaymentDeclarationDecisionRequestV1Dto: BackOfficePaymentDeclarationDecisionRequestV1Dto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackOfficePaymentDeclarationV1Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordDecision(submissionId, backOfficePaymentDeclarationDecisionRequestV1Dto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.recordDecision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshAddress(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshAddress(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.refreshAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reissueCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reissueCard(customerId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.reissueCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {DeleteAuthPersonDto} deleteAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAuthPerson(deleteAuthPersonDto: DeleteAuthPersonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAuthPerson(deleteAuthPersonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.removeAuthPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} country 
         * @param {string} regNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCompanyFromPortfolio(portfolioId: string, country: string, regNo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCompanyFromPortfolio(portfolioId, country, regNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.removeCompanyFromPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {DeleteAuthPersonDto} deleteAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEmailAuthPerson(deleteAuthPersonDto: DeleteAuthPersonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEmailAuthPerson(deleteAuthPersonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.removeEmailAuthPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDirectDebitMandatesV4200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendDirectDebitMandateV4(customerId, mandateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.resendDirectDebitMandateV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetBureau(resetRequest: ResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetBureau(resetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.resetBureau']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPinAttempt(customerId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPinAttempt(customerId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.resetPinAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetRulesToDefault(portfolioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetRulesToDefault(portfolioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.resetRulesToDefault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAlarm(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveAlarm(alarmId, resolveAlarmRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.resolveAlarm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} amlCheckId 
         * @param {AmlCheckResolutionRequest} amlCheckResolutionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAmlCheck(amlCheckId: string, amlCheckResolutionRequest: AmlCheckResolutionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveAmlCheck(amlCheckId, amlCheckResolutionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.resolveAmlCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasRole(\'BACKOFFICE_SALES\')
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesRoleChecker(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesRoleChecker(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.salesRoleChecker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} q 
         * @param {number} [n] 
         * @param {string} [t] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(q: string, n?: number, t?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FastSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(q, n, t, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} [search] 
         * @param {string} [customerId] 
         * @param {Array<string>} [country] 
         * @param {Array<string>} [partner] 
         * @param {Array<string>} [kycStatus] 
         * @param {Array<RequestStatus>} [requestStatus] 
         * @param {Array<PendingReason>} [pendingReason] 
         * @param {boolean} [hasPendingReasons] 
         * @param {Array<AgreementStatus>} [agreementStatus] 
         * @param {boolean} [snoozed] 
         * @param {Field} [sortBy] 
         * @param {Direction} [sortDirection] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCreditApplications(search?: string, customerId?: string, country?: Array<string>, partner?: Array<string>, kycStatus?: Array<string>, requestStatus?: Array<RequestStatus>, pendingReason?: Array<PendingReason>, hasPendingReasons?: boolean, agreementStatus?: Array<AgreementStatus>, snoozed?: boolean, sortBy?: Field, sortDirection?: Direction, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackofficeCreditApplicationV1Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCreditApplications(search, customerId, country, partner, kycStatus, requestStatus, pendingReason, hasPendingReasons, agreementStatus, snoozed, sortBy, sortDirection, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.searchCreditApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.searchTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddBankDataRequestDto} addBankDataRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAddBankDataEmail(addBankDataRequestDto: AddBankDataRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEmailResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAddBankDataEmail(addBankDataRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendAddBankDataEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Email agreement to all signatories
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAgreementEmailV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAgreementEmailV8(customerId, agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendAgreementEmailV8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Send reminder email for unsigned credit agreement
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAgreementReminderV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAgreementReminderV8(customerId, agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendAgreementReminderV8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendKycExpiredEmail(customerId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendKycExpiredEmail(customerId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendKycExpiredEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {boolean} [ssnWaiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendKycLinkEmail(customerId: string, body: string, ssnWaiver?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendKycLinkEmail(customerId, body, ssnWaiver, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendKycLinkEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendKycRenewalEmail(customerId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendKycRenewalEmail(customerId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendKycRenewalEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {MonthlyReportRequest} monthlyReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMonthlyReport(customerId: string, monthlyReportRequest: MonthlyReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMonthlyReport(customerId, monthlyReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendMonthlyReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NewBankDataSessionRequestDto} newBankDataSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNewBankDataSessionEmail(newBankDataSessionRequestDto: NewBankDataSessionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEmailResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNewBankDataSessionEmail(newBankDataSessionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendNewBankDataSessionEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} cid 
         * @param {string} pid 
         * @param {SmsRequestDto} smsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSms(cid: string, pid: string, smsRequestDto: SmsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSms(cid, pid, smsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendSms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} cid 
         * @param {string} phoneNumber 
         * @param {SmsRequestDto} smsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSmsToPhoneNumber(cid: string, phoneNumber: string, smsRequestDto: SmsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSmsToPhoneNumber(cid, phoneNumber, smsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendSmsToPhoneNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestKycReminderSms(request: Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestKycReminderSms(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendTestKycReminderSms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendWelcomeEmail(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendWelcomeEmail(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.sendWelcomeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonDto} updateAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAuthPersonId(updateAuthPersonDto: UpdateAuthPersonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAuthPersonId(updateAuthPersonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.setAuthPersonId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetIdDomainRequest} setIdDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDomainId(setIdDomainRequest: SetIdDomainRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDomainId(setIdDomainRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.setDomainId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeCardSyncResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncCard(customerId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.syncCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDirectDebitMandatesV4200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncDirectDebitMandateV4(customerId, mandateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.syncDirectDebitMandateV4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFile(customerId: string, id: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilexDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFile(customerId, id, uploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.syncFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPortfolio(portfolioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.syncPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Get a list of transaction conditions from Enfuce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionConditions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackOfficeTransactionConditionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionConditions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.transactionConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Trigger expense checker outcome migration
         * @param {boolean} [realRun] 
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trigger(realRun?: boolean, limit?: number, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseCheckerMigrationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trigger(realRun, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.trigger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerBusinessEvent(customerId: string, txId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerBusinessEvent(customerId, txId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.triggerBusinessEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerBusinessEventV2(customerId: string, txId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerBusinessEventV2(customerId, txId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.triggerBusinessEventV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauUnassingmentRequest} bureauUnassingmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassign(bureauUnassingmentRequest: BureauUnassingmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BureauUnassingmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassign(bureauUnassingmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.unassign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unauthorizedException(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unauthorizedException(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.unauthorizedException']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unresolveAlarm(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unresolveAlarm(alarmId, resolveAlarmRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.unresolveAlarm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {AccountDto} accountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccount(id: string, accountDto: AccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccount(id, accountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.updateAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonMailDto} updateAuthPersonMailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAuthPersonMail(updateAuthPersonMailDto: UpdateAuthPersonMailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAuthPersonMail(updateAuthPersonMailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.updateAuthPersonMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonPhoneDto} updateAuthPersonPhoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAuthPersonPhoneNumber(updateAuthPersonPhoneDto: UpdateAuthPersonPhoneDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAuthPersonPhoneNumber(updateAuthPersonPhoneDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.updateAuthPersonPhoneNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRoleOrSalesRoleAndAllowed(#patch.onlyInvite())
         * @param {string} id 
         * @param {string} personId 
         * @param {PersonPatchDto} personPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePerson(id: string, personId: string, personPatchDto: PersonPatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePerson(id, personId, personPatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.updatePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {UpdateRuleRequest} updateRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRuleWithParameters(portfolioId: string, countryCode: string, ruleCode: string, updateRuleRequest: UpdateRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRuleWithParameters(portfolioId, countryCode, ruleCode, updateRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.updateRuleWithParameters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {TextProcessorPatternPatchDto} textProcessorPatternPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTextProcessorConfiguration(id: string, textProcessorPatternPatchDto: TextProcessorPatternPatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextProcessorPatternDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTextProcessorConfiguration(id, textProcessorPatternPatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.updateTextProcessorConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {AccountXYear} accountXYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateYear(id: string, accountXYear: AccountXYear, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountXYear>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateYear(id, accountXYear, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.updateYear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<MonitoringPortfolioCreditSafeMapping>} monitoringPortfolioCreditSafeMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCreditsafeIdMappings(monitoringPortfolioCreditSafeMapping: Array<MonitoringPortfolioCreditSafeMapping>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MonitoringPortfolioUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCreditsafeIdMappings(monitoringPortfolioCreditSafeMapping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.uploadCreditsafeIdMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whiteListPaymentV1(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whiteListPaymentV1(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackOfficeAPIApi.whiteListPaymentV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BackOfficeAPIApi - factory interface
 * @export
 */
export const BackOfficeAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BackOfficeAPIApiFp(configuration)
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsBasic(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackOfficeAccountBasicDto>> {
            return localVarFp.accountsBasic(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {string} plasticId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePlastic(customerId: string, cardId: string, plasticId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.activatePlastic(customerId, cardId, plasticId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateRule(portfolioId: string, countryCode: string, ruleCode: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.activateRule(portfolioId, countryCode, ruleCode, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        add(body: any, options?: RawAxiosRequestConfig): AxiosPromise<SmsTemplateDto> {
            return localVarFp.add(body, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        add1(customerId: string, body: any, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteDto> {
            return localVarFp.add1(customerId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} country 
         * @param {string} regNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyToPortfolio(portfolioId: string, country: string, regNo: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCompanyToPortfolio(portfolioId, country, regNo, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFile(customerId: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadUrlDto> {
            return localVarFp.addFile(customerId, uploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} itemId 
         * @param {SnoozeDto} snoozeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSnooze(itemId: string, snoozeDto: SnoozeDto, options?: RawAxiosRequestConfig): AxiosPromise<SnoozeDto> {
            return localVarFp.addSnooze(itemId, snoozeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} validFrom 
         * @param {number} foodAndBeverageDeductionLimit 
         * @param {number} simpleFoodDeductionLimit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSwedishRepresentationVATValues(validFrom: string, foodAndBeverageDeductionLimit: number, simpleFoodDeductionLimit: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSwedishRepresentationVATValues(validFrom, foodAndBeverageDeductionLimit, simpleFoodDeductionLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alreadyExistingException(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.alreadyExistingException(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauRelationshipRequest} bureauRelationshipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assign(bureauRelationshipRequest: BureauRelationshipRequest, options?: RawAxiosRequestConfig): AxiosPromise<BureauRelationshipResponse> {
            return localVarFp.assign(bureauRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backofficeRoleChecker(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.backofficeRoleChecker(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PersonLoginRequest} personLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bizOpsLogin(personLoginRequest: PersonLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bizOpsLogin(personLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bureau(bureauId: string, options?: RawAxiosRequestConfig): AxiosPromise<BureauConfigResponse> {
            return localVarFp.bureau(bureauId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bureauClients(bureauId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BureauRelationshipResponse>> {
            return localVarFp.bureauClients(bureauId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} bureauId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bureauPendingTasks(bureauId: string, options?: RawAxiosRequestConfig): AxiosPromise<BureauClientsPendingTaskAndAvailableResponse> {
            return localVarFp.bureauPendingTasks(bureauId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDirectDebitMandatesV4200ResponseInner> {
            return localVarFp.cancelDirectDebitMandateV4(customerId, mandateId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {string} userAgent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPisDeposit(customerId: string, depositId: string, userAgent: string, options?: RawAxiosRequestConfig): AxiosPromise<BackofficePisDepositResponseV1Dto> {
            return localVarFp.cancelPisDeposit(customerId, depositId, userAgent, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardDeliveryAddress(customerId: string, personId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeCardDeliveryAddressResponseDto> {
            return localVarFp.cardDeliveryAddress(customerId, personId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cards(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackOfficeCardsDto>> {
            return localVarFp.cards(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary churn customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        churnCustomer(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.churnCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        client(clientId: string, options?: RawAxiosRequestConfig): AxiosPromise<BureauRelationshipResponse> {
            return localVarFp.client(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauConfigRequest} bureauConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configure(bureauConfigRequest: BureauConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<BureauConfigResponse> {
            return localVarFp.configure(bureauConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} [search] 
         * @param {string} [customerId] 
         * @param {Array<string>} [country] 
         * @param {Array<string>} [partner] 
         * @param {Array<string>} [kycStatus] 
         * @param {Array<RequestStatus>} [requestStatus] 
         * @param {Array<PendingReason>} [pendingReason] 
         * @param {boolean} [hasPendingReasons] 
         * @param {Array<AgreementStatus>} [agreementStatus] 
         * @param {boolean} [snoozed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCreditApplications(search?: string, customerId?: string, country?: Array<string>, partner?: Array<string>, kycStatus?: Array<string>, requestStatus?: Array<RequestStatus>, pendingReason?: Array<PendingReason>, hasPendingReasons?: boolean, agreementStatus?: Array<AgreementStatus>, snoozed?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeCreditApplicationCountV1Dto> {
            return localVarFp.countCreditApplications(search, customerId, country, partner, kycStatus, requestStatus, pendingReason, hasPendingReasons, agreementStatus, snoozed, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {AccountDto} accountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(accountDto: AccountDto, options?: RawAxiosRequestConfig): AxiosPromise<AccountDto> {
            return localVarFp.createAccount(accountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Create a new Agreement with status draft
         * @param {string} customerId 
         * @param {BackOfficeAgreementCreationDtoV8} backOfficeAgreementCreationDtoV8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgreementV8(customerId: string, backOfficeAgreementCreationDtoV8: BackOfficeAgreementCreationDtoV8, options?: RawAxiosRequestConfig): AxiosPromise<GetAllAgreementsV8200ResponseInner> {
            return localVarFp.createAgreementV8(customerId, backOfficeAgreementCreationDtoV8, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreateAuthPersonForEmailDto} createAuthPersonForEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuthPersonForEmail(createAuthPersonForEmailDto: CreateAuthPersonForEmailDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createAuthPersonForEmail(createAuthPersonForEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary create a new customer entity
         * @param {BackOfficeCustomerCreateDtoV2} backOfficeCustomerCreateDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(backOfficeCustomerCreateDtoV2: BackOfficeCustomerCreateDtoV2, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeCustomerDtoV2> {
            return localVarFp.createCustomer(backOfficeCustomerCreateDtoV2, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {CreateDirectDebitMandateV4Request} createDirectDebitMandateV4Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectDebitMandateV4(customerId: string, createDirectDebitMandateV4Request: CreateDirectDebitMandateV4Request, options?: RawAxiosRequestConfig): AxiosPromise<GetDirectDebitMandatesV4200ResponseInner> {
            return localVarFp.createDirectDebitMandateV4(customerId, createDirectDebitMandateV4Request, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreatePasswordRequestDto} createPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasswords(createPasswordRequestDto: CreatePasswordRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPasswords(createPasswordRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BackOfficeCreatePaymentForCustomerRequestDto} backOfficeCreatePaymentForCustomerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayment(backOfficeCreatePaymentForCustomerRequestDto: BackOfficeCreatePaymentForCustomerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficePaymentResponseDto> {
            return localVarFp.createPayment(backOfficeCreatePaymentForCustomerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {CreatePersonDto} createPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonWithRoles(id: string, createPersonDto: CreatePersonDto, options?: RawAxiosRequestConfig): AxiosPromise<PersonDto> {
            return localVarFp.createPersonWithRoles(id, createPersonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePortfolioRequest} createPortfolioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortfolio(createPortfolioRequest: CreatePortfolioRequest, options?: RawAxiosRequestConfig): AxiosPromise<Portfolio> {
            return localVarFp.createPortfolio(createPortfolioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Create new signatories data
         * @param {string} customerId 
         * @param {Array<BackOfficeSignatoryDto>} backOfficeSignatoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSignatories(customerId: string, backOfficeSignatoryDto: Array<BackOfficeSignatoryDto>, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeSignatoryInfoResponseDto> {
            return localVarFp.createSignatories(customerId, backOfficeSignatoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {CreatePaymentRequestDtoV2} createPaymentRequestDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createV2(createPaymentRequestDtoV2: CreatePaymentRequestDtoV2, options?: RawAxiosRequestConfig): AxiosPromise<PaymentRequestDtoV2> {
            return localVarFp.createV2(createPaymentRequestDtoV2, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {VoucherDto} voucherDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoucher(voucherDto: VoucherDto, options?: RawAxiosRequestConfig): AxiosPromise<VoucherDto> {
            return localVarFp.createVoucher(voucherDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {AccountXYear} accountXYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createYear(accountXYear: AccountXYear, options?: RawAxiosRequestConfig): AxiosPromise<AccountXYear> {
            return localVarFp.createYear(accountXYear, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateRule(portfolioId: string, countryCode: string, ruleCode: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivateRule(portfolioId, countryCode, ruleCode, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1(customerId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.delete1(customerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {PersonsToDeleteAuthPersonIds} personsToDeleteAuthPersonIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthPerson(personsToDeleteAuthPersonIds: PersonsToDeleteAuthPersonIds, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAuthPerson(personsToDeleteAuthPersonIds, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} authpersonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExistingAuthPerson(authpersonId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteExistingAuthPerson(authpersonId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFeatureName} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeatureOverride(customerId: string, featureName: BillingSettingsFeatureName, options?: RawAxiosRequestConfig): AxiosPromise<BillingSettings> {
            return localVarFp.deleteFeatureOverride(customerId, featureName, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(customerId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<FilexDto> {
            return localVarFp.deleteFile(customerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFieldName} fieldName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOverrides(customerId: string, fieldName: BillingSettingsFieldName, options?: RawAxiosRequestConfig): AxiosPromise<BillingSettings> {
            return localVarFp.deleteOverrides(customerId, fieldName, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} paymentWhiteListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentWhiteListV1(customerId: string, paymentWhiteListId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePaymentWhiteListV1(customerId, paymentWhiteListId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePerson(id: string, personId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePerson(id, personId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreorderCardV1(customerId: string, cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePreorderCardV1(customerId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSnooze(itemId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSnooze(itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextProcessorConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTextProcessorConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteYear(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteYear(id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        directLoginToken(id: string, personId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.directLoginToken(id, personId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FetchRequestDto} fetchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetch(fetchRequestDto: FetchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<FetchResponseDto> {
            return localVarFp.fetch(fetchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAndSaveNotifications(fromDate: string, toDate: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.fetchAndSaveNotifications(fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<SmsTemplateDto>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBy(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomerNoteDto>> {
            return localVarFp.findBy(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary List audit logs
         * @param {string} [customerId] 
         * @param {string} [resourceId] 
         * @param {Array<string>} [hierarchyElement] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByCustomerId(customerId?: string, resourceId?: string, hierarchyElement?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditLogDto>> {
            return localVarFp.findByCustomerId(customerId, resourceId, hierarchyElement, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary fetch a customer entity by id
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomerById(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeCustomerDtoV2> {
            return localVarFp.findCustomerById(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEInvoiceAddresses(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<EInvoiceAddress> {
            return localVarFp.findEInvoiceAddresses(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forbiddenException(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.forbiddenException(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalException(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.generalException(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SmsTemplateDto> {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1(customerId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteDto> {
            return localVarFp.get1(customerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccount(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<PrepaidAccountResponse> {
            return localVarFp.getAccount(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAccount3(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountV3Response> {
            return localVarFp.getAccount3(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get an accounts balance, available, and creditlimit. This requires a downstream call to enfuce.
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountStatusV5(customerId: string, accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeAccountStatusV5> {
            return localVarFp.getAccountStatusV5(customerId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountV2(customerId: string, accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeAccountGetDto> {
            return localVarFp.getAccountV2(customerId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get an account on customer
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountV5(customerId: string, accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAccountsV5200ResponseInner> {
            return localVarFp.getAccountV5(customerId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts(year?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountDto>> {
            return localVarFp.getAccounts(year, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsV2(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackOfficeAccountGetDto>> {
            return localVarFp.getAccountsV2(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get a list of all accounts on customer
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsV5(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAccountsV5200ResponseInner>> {
            return localVarFp.getAccountsV5(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivationGuide(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivationGuideDto> {
            return localVarFp.getActivationGuide(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivationGuideVisibility(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivationGuideDto> {
            return localVarFp.getActivationGuideVisibility(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveAlarms(pageNumber?: number, pageSize?: number, sortDirection?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAlarmsResponseDto> {
            return localVarFp.getActiveAlarms(pageNumber, pageSize, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSessions(pageSize?: number, pageNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<ActiveSessionsResponseDto> {
            return localVarFp.getActiveSessions(pageSize, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Get agreement details for given agreement-id
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllAgreementsV8200ResponseInner> {
            return localVarFp.getAgreementV8(customerId, agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlarmById(alarmId: string, options?: RawAxiosRequestConfig): AxiosPromise<AlarmItemDto> {
            return localVarFp.getAlarmById(alarmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlarmsByCustomerId(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AlarmWithLogDto>> {
            return localVarFp.getAlarmsByCustomerId(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get a list of all agreements on customer
         * @param {string} customerId 
         * @param {Array<BackOfficeAgreementTypeV8>} [agreementType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreementsV8(customerId: string, agreementType?: Array<BackOfficeAgreementTypeV8>, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAllAgreementsV8200ResponseInner>> {
            return localVarFp.getAllAgreementsV8(customerId, agreementType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [status] 
         * @param {string} [companyName] 
         * @param {string} [sortDirection] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlarms(pageNumber?: number, pageSize?: number, status?: string, companyName?: string, sortDirection?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAlarmsResponseDto> {
            return localVarFp.getAllAlarms(pageNumber, pageSize, status, companyName, sortDirection, search, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContexts(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAllContexts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEventRules(options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyChangeRule>> {
            return localVarFp.getAllEventRules(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMonthlyReports(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MonthlyReportLog>> {
            return localVarFp.getAllMonthlyReports(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificationEvents(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyChange>> {
            return localVarFp.getAllNotificationEvents(fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTextProcessorConfigurations(options?: RawAxiosRequestConfig): AxiosPromise<Array<TextProcessorPatternDto>> {
            return localVarFp.getAllTextProcessorConfigurations(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [years] 
         * @param {Array<number>} [accounts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVouchers(from?: string, to?: string, years?: Array<string>, accounts?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<VoucherDto>> {
            return localVarFp.getAllVouchers(from, to, years, accounts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authpersonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthPersonInfo(authpersonId: string, options?: RawAxiosRequestConfig): AxiosPromise<AuthPersonInfoDto> {
            return localVarFp.getAuthPersonInfo(authpersonId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Offset, start transaction list at this offset. Limit is how many transactions to return. transactionDate do not have a timezone
         * @param {string} customerId 
         * @param {number} [offset] pagination offset
         * @param {number} [limit] pagination limit
         * @param {string} [from] from date (inclusive) in ISO format, yyyy-MM-dd
         * @param {string} [to] to date (inclusive) in ISO format, yyyy-MM-dd
         * @param {number} [min] min transaction amount (inclusive)
         * @param {number} [max] max transaction amount (inclusive)
         * @param {Array<TransactionFilters>} [onlyinclude] various transaction property filters, some are mutually exclusive
         * @param {Array<TransactionFilters>} [exclude] 
         * @param {Array<AttestStatus>} [attestStatus] 
         * @param {string} [query] Free text query search. At least 3 characters, otherwise ignored
         * @param {Array<string>} [personIds] \&#39;or-ed\&#39; person id\&#39;s to query for, if omitted then transactions for all users will be returned. note: returned set increases with with more personIds and decreases with less personId, except for the empty set which returns all transactions
         * @param {Array<string>} [cardIds] 
         * @param {Array<BackOfficeTx2StatusFilter2>} [status] Filter on transaction status. Leave empty to include all statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoTransactionsV2(customerId: string, offset?: number, limit?: number, from?: string, to?: string, min?: number, max?: number, onlyinclude?: Array<TransactionFilters>, exclude?: Array<TransactionFilters>, attestStatus?: Array<AttestStatus>, query?: string, personIds?: Array<string>, cardIds?: Array<string>, status?: Array<BackOfficeTx2StatusFilter2>, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBoTransactionsV2DefaultResponseInner>> {
            return localVarFp.getBoTransactionsV2(customerId, offset, limit, from, to, min, max, onlyinclude, exclude, attestStatus, query, personIds, cardIds, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerId(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BankDataResponseDto> {
            return localVarFp.getByCustomerId(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<VisaCardResponse> {
            return localVarFp.getCard(customerId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardBalanceConfig(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<CardBalanceConfigResponseDto> {
            return localVarFp.getCardBalanceConfig(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardConfig(customerId: string, cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<CardConfig> {
            return localVarFp.getCardConfig(customerId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardCreditV2(customerId: string, creditId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeCardCreditGetV2Dto> {
            return localVarFp.getCardCreditV2(customerId, creditId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardCreditsV2(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackOfficeCardCreditGetV2Dto>> {
            return localVarFp.getCardCreditsV2(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardPlastics(customerId: string, cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ListPlasticResponse>> {
            return localVarFp.getCardPlastics(customerId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardV1(customerId: string, cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeCardsDto> {
            return localVarFp.getCardV1(customerId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCards(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<VisaCardListResponse>> {
            return localVarFp.getCards(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporateCustomer(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<CorporateCustomerResponse> {
            return localVarFp.getCorporateCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditApplication(requestId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeCreditApplicationV1Dto> {
            return localVarFp.getCreditApplication(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectDebitMandatesV4(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetDirectDebitMandatesV4200ResponseInner>> {
            return localVarFp.getDirectDebitMandatesV4(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventRulesByCountry(countryCode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyChangeRule>> {
            return localVarFp.getEventRulesByCountry(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventRulesForPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyChangeRule>> {
            return localVarFp.getEventRulesForPortfolio(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventRulesForPortfolioAndCountry(portfolioId: string, countryCode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyChangeRule>> {
            return localVarFp.getEventRulesForPortfolioAndCountry(portfolioId, countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {Array<string>} [contexts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiles(customerId: string, contexts?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<FilexDto>> {
            return localVarFp.getFiles(customerId, contexts, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGermanyDistrictCourtCodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<DeDistrictCourtDto>> {
            return localVarFp.getGermanyDistrictCourtCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Array<InboxItemType>} [types] Filter for specific types. Accepts a comma separated list. If omitted, all types are returned
         * @param {boolean} [snoozed] should snoozed items be included or not
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getInbox(types?: Array<InboxItemType>, snoozed?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<InboxItemDto>> {
            return localVarFp.getInbox(types, snoozed, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicingConfigV1(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeInvoicingConfigDto> {
            return localVarFp.getInvoicingConfigV1(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSession(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<LatestSessionResponseDto> {
            return localVarFp.getLatestSession(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartners(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getPartners(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayment(paymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficePaymentResponseDto> {
            return localVarFp.getPayment(paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDeclaration(submissionId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficePaymentDeclarationV1Dto> {
            return localVarFp.getPaymentDeclaration(submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReceiverV1(paymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeReceiverInformationDto> {
            return localVarFp.getPaymentReceiverV1(paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestV2(paymentRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentRequestDtoV2> {
            return localVarFp.getPaymentRequestV2(paymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [customerId] 
         * @param {string} [cardCreditId] 
         * @param {Array<string>} [currency] 
         * @param {boolean} [hasPaidEnough] 
         * @param {Array<PaymentRequestStatusDtoV2>} [status] 
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {string} [paymentRequestDateFrom] 
         * @param {string} [paymentRequestDateTo] 
         * @param {string} [periodFrom] 
         * @param {string} [periodTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsV2(customerId?: string, cardCreditId?: string, currency?: Array<string>, hasPaidEnough?: boolean, status?: Array<PaymentRequestStatusDtoV2>, dueDateFrom?: string, dueDateTo?: string, paymentRequestDateFrom?: string, paymentRequestDateTo?: string, periodFrom?: string, periodTo?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentRequestDtoV2>> {
            return localVarFp.getPaymentRequestsV2(customerId, cardCreditId, currency, hasPaidEnough, status, dueDateFrom, dueDateTo, paymentRequestDateFrom, paymentRequestDateTo, periodFrom, periodTo, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentWhiteListV1(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackOfficePaymentWhiteListDto>> {
            return localVarFp.getPaymentWhiteListV1(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Array<PaymentState>} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments(state?: Array<PaymentState>, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackOfficePaymentResponseDto>> {
            return localVarFp.getPayments(state, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutRequest(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PayoutRequestDto> {
            return localVarFp.getPayoutRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfV2(paymentRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentRequestPdfDtoV2> {
            return localVarFp.getPdfV2(paymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonsWithRoles(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PersonDto>> {
            return localVarFp.getPersonsWithRoles(id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreSignedUrl(customerId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getPreSignedUrl(customerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferredDirectDebitMandateV4(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDirectDebitMandatesV4200ResponseInner> {
            return localVarFp.getPreferredDirectDebitMandateV4(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivateCustomers(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PrivateCustomerResponse>> {
            return localVarFp.getPrivateCustomers(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawAccountV3(customerId: string, accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountV3Response> {
            return localVarFp.getRawAccountV3(customerId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawAccountV4(customerId: string, accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<PrepaidAccountResponse> {
            return localVarFp.getRawAccountV4(customerId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawAccountsV3(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ListV3AccountResponse>> {
            return localVarFp.getRawAccountsV3(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRawAccountsV4(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ListPrepaidAccountResponse>> {
            return localVarFp.getRawAccountsV4(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orgNo 
         * @param {string} country 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedNotifications(orgNo: string, country: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyChange>> {
            return localVarFp.getSavedNotifications(orgNo, country, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary Get signatories data
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignatories(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeSignatoryInfoResponseDto> {
            return localVarFp.getSignatories(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction(customerId: string, txId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionDto> {
            return localVarFp.getTransaction(customerId, txId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @summary offset takes precedence over page if provided. Page is still available for backward compatibility. limit defaults to 20
         * @param {string} customerId 
         * @param {number} [page] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsCombined(customerId: string, page?: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransactionDto>> {
            return localVarFp.getTransactionsCombined(customerId, page, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpgradeOption(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionPlanUpgradeResponse> {
            return localVarFp.getUpgradeOption(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [years] 
         * @param {Array<number>} [accounts] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVouchersResultReport(from?: string, to?: string, years?: Array<string>, accounts?: Array<number>, currency?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountResultDto>> {
            return localVarFp.getVouchersResultReport(from, to, years, accounts, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYears(options?: RawAxiosRequestConfig): AxiosPromise<Array<AccountXYear>> {
            return localVarFp.getYears(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleOAuthRedir(callback: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.googleOAuthRedir(callback, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illegalArgumentException(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.illegalArgumentException(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illegalStateException(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.illegalStateException(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {string} userAgent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectPisDeposit(customerId: string, depositId: string, userAgent: string, options?: RawAxiosRequestConfig): AxiosPromise<BackofficePisDepositResponseV1Dto> {
            return localVarFp.inspectPisDeposit(customerId, depositId, userAgent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isLoggedIn(options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeGoogleAuthResponseDto> {
            return localVarFp.isLoggedIn(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kycApproved(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.kycApproved(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackOfficeCustomerKycRequiresRenewalDtoV2} backOfficeCustomerKycRequiresRenewalDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kycRequiresRenewal(customerId: string, backOfficeCustomerKycRequiresRenewalDtoV2: BackOfficeCustomerKycRequiresRenewalDtoV2, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.kycRequiresRenewal(customerId, backOfficeCustomerKycRequiresRenewalDtoV2, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options?: RawAxiosRequestConfig): AxiosPromise<Array<BureauConfigResponse>> {
            return localVarFp.list(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} [searchQuery] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompaniesInPortfolio(portfolioId: string, searchQuery?: string, pageSize?: number, page?: number, countryCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<Result> {
            return localVarFp.listCompaniesInPortfolio(portfolioId, searchQuery, pageSize, page, countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} depositId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPisDepositEvents(customerId: string, depositId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackofficePisDepositEventResponseV1Dto>> {
            return localVarFp.listPisDepositEvents(customerId, depositId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPisDeposits(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackofficePisDepositResponseV1Dto>> {
            return localVarFp.listPisDeposits(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPortfolios(options?: RawAxiosRequestConfig): AxiosPromise<Array<Portfolio>> {
            return localVarFp.listPortfolios(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        log(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomerEventDto>> {
            return localVarFp.log(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAlarmUnderReview(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAlarmUnderReview(alarmId, resolveAlarmRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAuth0Users(requestDto: RequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migrateAuth0Users(requestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notFoundException(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.notFoundException(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyCardCreditDenied(customerId: string, creditId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyCardCreditDenied(customerId, creditId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyCardCreditRaiseDenied(customerId: string, creditId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyCardCreditRaiseDenied(customerId, creditId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackOfficeOrderCardRequestDtoV3} backOfficeOrderCardRequestDtoV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCardV3(customerId: string, backOfficeOrderCardRequestDtoV3: BackOfficeOrderCardRequestDtoV3, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderCardV3(customerId, backOfficeOrderCardRequestDtoV3, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {PatchPrepaidResourceBody} patchPrepaidResourceBody 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchAccount(customerId: string, patchPrepaidResourceBody: PatchPrepaidResourceBody, options?: RawAxiosRequestConfig): AxiosPromise<ResourceResponse> {
            return localVarFp.patchAccount(customerId, patchPrepaidResourceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {BackOfficeAccountPatchDto} backOfficeAccountPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountV2(customerId: string, accountId: string, backOfficeAccountPatchDto: BackOfficeAccountPatchDto, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeAccountGetDto> {
            return localVarFp.patchAccountV2(customerId, accountId, backOfficeAccountPatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {ActivationGuidePatchDto} activationGuidePatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivationGuideVisibility(customerId: string, activationGuidePatchDto: ActivationGuidePatchDto, options?: RawAxiosRequestConfig): AxiosPromise<ActivationGuideDto> {
            return localVarFp.patchActivationGuideVisibility(customerId, activationGuidePatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {ActivationGuidePatchDto} activationGuidePatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivationGuideVisibility1(customerId: string, activationGuidePatchDto: ActivationGuidePatchDto, options?: RawAxiosRequestConfig): AxiosPromise<ActivationGuideDto> {
            return localVarFp.patchActivationGuideVisibility1(customerId, activationGuidePatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {PatchStandardResourceBody} patchStandardResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCard(customerId: string, cardId: string, patchStandardResourceBody: PatchStandardResourceBody, options?: RawAxiosRequestConfig): AxiosPromise<ResourceResponse> {
            return localVarFp.patchCard(customerId, cardId, patchStandardResourceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {CardBalanceConfigPatchDto} cardBalanceConfigPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCardBalanceConfig(customerId: string, cardBalanceConfigPatchDto: CardBalanceConfigPatchDto, options?: RawAxiosRequestConfig): AxiosPromise<CardBalanceConfigResponseDto> {
            return localVarFp.patchCardBalanceConfig(customerId, cardBalanceConfigPatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {CardConfigPatchRequestDto} cardConfigPatchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCardConfig(customerId: string, cardId: string, cardConfigPatchRequestDto: CardConfigPatchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CardConfig> {
            return localVarFp.patchCardConfig(customerId, cardId, cardConfigPatchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} creditId 
         * @param {BackOfficeCardCreditPatchV2Dto} backOfficeCardCreditPatchV2Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCardCreditV2(customerId: string, creditId: string, backOfficeCardCreditPatchV2Dto: BackOfficeCardCreditPatchV2Dto, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeCardCreditGetV2Dto> {
            return localVarFp.patchCardCreditV2(customerId, creditId, backOfficeCardCreditPatchV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {BackOfficeCardPatchDto} backOfficeCardPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCardV1(customerId: string, cardId: string, backOfficeCardPatchDto: BackOfficeCardPatchDto, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeCardsDto> {
            return localVarFp.patchCardV1(customerId, cardId, backOfficeCardPatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRoleOrSalesRoleAndAllowed(#patch.changesOnlyProducts() || #patch.changesOnlyChannel())
         * @param {string} customerId 
         * @param {BackOfficeCustomerPatchDtoV2} backOfficeCustomerPatchDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomer(customerId: string, backOfficeCustomerPatchDtoV2: BackOfficeCustomerPatchDtoV2, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficeCustomerDtoV2> {
            return localVarFp.patchCustomer(customerId, backOfficeCustomerPatchDtoV2, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsFeatureOverridePatch} billingSettingsFeatureOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFeatureOverrides(customerId: string, billingSettingsFeatureOverridePatch: BillingSettingsFeatureOverridePatch, options?: RawAxiosRequestConfig): AxiosPromise<BillingSettings> {
            return localVarFp.patchFeatureOverrides(customerId, billingSettingsFeatureOverridePatch, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {BackofficeInvoicingConfigPatchDto} backofficeInvoicingConfigPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInvoicingConfigV1(customerId: string, backofficeInvoicingConfigPatchDto: BackofficeInvoicingConfigPatchDto, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeInvoicingConfigDto> {
            return localVarFp.patchInvoicingConfigV1(customerId, backofficeInvoicingConfigPatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsOverridePatch} billingSettingsOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOverrides(customerId: string, billingSettingsOverridePatch: BillingSettingsOverridePatch, options?: RawAxiosRequestConfig): AxiosPromise<BillingSettings> {
            return localVarFp.patchOverrides(customerId, billingSettingsOverridePatch, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {BackOfficePatchPaymentRequestDto} backOfficePatchPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPayment(paymentId: string, backOfficePatchPaymentRequestDto: BackOfficePatchPaymentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficePaymentResponseDto> {
            return localVarFp.patchPayment(paymentId, backOfficePatchPaymentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {PatchPaymentRequestDtoV2} patchPaymentRequestDtoV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentRequestV2(paymentRequestId: string, patchPaymentRequestDtoV2: PatchPaymentRequestDtoV2, options?: RawAxiosRequestConfig): AxiosPromise<PaymentRequestDtoV2> {
            return localVarFp.patchPaymentRequestV2(paymentRequestId, patchPaymentRequestDtoV2, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {PatchV3ResourceBody} patchV3ResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRawAccountV3(customerId: string, accountId: string, patchV3ResourceBody: PatchV3ResourceBody, options?: RawAxiosRequestConfig): AxiosPromise<ResourceResponse> {
            return localVarFp.patchRawAccountV3(customerId, accountId, patchV3ResourceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} accountId 
         * @param {PatchPrepaidResourceBody} patchPrepaidResourceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRawAccountV4(customerId: string, accountId: string, patchPrepaidResourceBody: PatchPrepaidResourceBody, options?: RawAxiosRequestConfig): AxiosPromise<ResourceResponse> {
            return localVarFp.patchRawAccountV4(customerId, accountId, patchPrepaidResourceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {BillingSettingsTrialOverridePatch} billingSettingsTrialOverridePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTrialOverrides(customerId: string, billingSettingsTrialOverridePatch: BillingSettingsTrialOverridePatch, options?: RawAxiosRequestConfig): AxiosPromise<BillingSettings> {
            return localVarFp.patchTrialOverrides(customerId, billingSettingsTrialOverridePatch, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} id 
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        person(id: string, personId: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonDto> {
            return localVarFp.person(id, personId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRecalculateV2(paymentRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentRequestDtoV2> {
            return localVarFp.postRecalculateV2(paymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(id: string, body: any, options?: RawAxiosRequestConfig): AxiosPromise<SmsTemplateDto> {
            return localVarFp.put(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put1(customerId: string, id: string, body: any, options?: RawAxiosRequestConfig): AxiosPromise<CustomerNoteDto> {
            return localVarFp.put1(customerId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole() Idempotent write of a projected credit application row. Rows with a projectedAt older than or equal to the stored row are ignored.
         * @param {string} requestId 
         * @param {BackofficeCreditApplicationV1Dto} backofficeCreditApplicationV1Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCreditApplication(requestId: string, backofficeCreditApplicationV1Dto: BackofficeCreditApplicationV1Dto, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeCreditApplicationProjectionResultV1Dto> {
            return localVarFp.putCreditApplication(requestId, backofficeCreditApplicationV1Dto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} submissionId 
         * @param {BackOfficePaymentDeclarationDecisionRequestV1Dto} backOfficePaymentDeclarationDecisionRequestV1Dto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordDecision(submissionId: string, backOfficePaymentDeclarationDecisionRequestV1Dto: BackOfficePaymentDeclarationDecisionRequestV1Dto, options?: RawAxiosRequestConfig): AxiosPromise<BackOfficePaymentDeclarationV1Dto> {
            return localVarFp.recordDecision(submissionId, backOfficePaymentDeclarationDecisionRequestV1Dto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAddress(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.refreshAddress(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResourceResponse> {
            return localVarFp.reissueCard(customerId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {DeleteAuthPersonDto} deleteAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAuthPerson(deleteAuthPersonDto: DeleteAuthPersonDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeAuthPerson(deleteAuthPersonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} country 
         * @param {string} regNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCompanyFromPortfolio(portfolioId: string, country: string, regNo: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCompanyFromPortfolio(portfolioId, country, regNo, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {DeleteAuthPersonDto} deleteAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmailAuthPerson(deleteAuthPersonDto: DeleteAuthPersonDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeEmailAuthPerson(deleteAuthPersonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDirectDebitMandatesV4200ResponseInner> {
            return localVarFp.resendDirectDebitMandateV4(customerId, mandateId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {ResetRequest} resetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetBureau(resetRequest: ResetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResetResponse> {
            return localVarFp.resetBureau(resetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPinAttempt(customerId: string, cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResourceResponse> {
            return localVarFp.resetPinAttempt(customerId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetRulesToDefault(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetRulesToDefault(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAlarm(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resolveAlarm(alarmId, resolveAlarmRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} amlCheckId 
         * @param {AmlCheckResolutionRequest} amlCheckResolutionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAmlCheck(amlCheckId: string, amlCheckResolutionRequest: AmlCheckResolutionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resolveAmlCheck(amlCheckId, amlCheckResolutionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasRole(\'BACKOFFICE_SALES\')
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesRoleChecker(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.salesRoleChecker(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} q 
         * @param {number} [n] 
         * @param {string} [t] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(q: string, n?: number, t?: string, options?: RawAxiosRequestConfig): AxiosPromise<FastSearchResult> {
            return localVarFp.search(q, n, t, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} [search] 
         * @param {string} [customerId] 
         * @param {Array<string>} [country] 
         * @param {Array<string>} [partner] 
         * @param {Array<string>} [kycStatus] 
         * @param {Array<RequestStatus>} [requestStatus] 
         * @param {Array<PendingReason>} [pendingReason] 
         * @param {boolean} [hasPendingReasons] 
         * @param {Array<AgreementStatus>} [agreementStatus] 
         * @param {boolean} [snoozed] 
         * @param {Field} [sortBy] 
         * @param {Direction} [sortDirection] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCreditApplications(search?: string, customerId?: string, country?: Array<string>, partner?: Array<string>, kycStatus?: Array<string>, requestStatus?: Array<RequestStatus>, pendingReason?: Array<PendingReason>, hasPendingReasons?: boolean, agreementStatus?: Array<AgreementStatus>, snoozed?: boolean, sortBy?: Field, sortDirection?: Direction, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackofficeCreditApplicationV1Dto>> {
            return localVarFp.searchCreditApplications(search, customerId, country, partner, kycStatus, requestStatus, pendingReason, hasPendingReasons, agreementStatus, snoozed, sortBy, sortDirection, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.searchTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddBankDataRequestDto} addBankDataRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddBankDataEmail(addBankDataRequestDto: AddBankDataRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SendEmailResponseDto> {
            return localVarFp.sendAddBankDataEmail(addBankDataRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Email agreement to all signatories
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAgreementEmailV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendAgreementEmailV8(customerId, agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Send reminder email for unsigned credit agreement
         * @param {string} customerId 
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAgreementReminderV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendAgreementReminderV8(customerId, agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKycExpiredEmail(customerId: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendKycExpiredEmail(customerId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {boolean} [ssnWaiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKycLinkEmail(customerId: string, body: string, ssnWaiver?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendKycLinkEmail(customerId, body, ssnWaiver, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKycRenewalEmail(customerId: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendKycRenewalEmail(customerId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {MonthlyReportRequest} monthlyReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMonthlyReport(customerId: string, monthlyReportRequest: MonthlyReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendMonthlyReport(customerId, monthlyReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NewBankDataSessionRequestDto} newBankDataSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewBankDataSessionEmail(newBankDataSessionRequestDto: NewBankDataSessionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SendEmailResponseDto> {
            return localVarFp.sendNewBankDataSessionEmail(newBankDataSessionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} cid 
         * @param {string} pid 
         * @param {SmsRequestDto} smsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSms(cid: string, pid: string, smsRequestDto: SmsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendSms(cid, pid, smsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} cid 
         * @param {string} phoneNumber 
         * @param {SmsRequestDto} smsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSmsToPhoneNumber(cid: string, phoneNumber: string, smsRequestDto: SmsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendSmsToPhoneNumber(cid, phoneNumber, smsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestKycReminderSms(request: Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTestKycReminderSms(request, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullOrSalesRole()
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendWelcomeEmail(customerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendWelcomeEmail(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonDto} updateAuthPersonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAuthPersonId(updateAuthPersonDto: UpdateAuthPersonDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setAuthPersonId(updateAuthPersonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetIdDomainRequest} setIdDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDomainId(setIdDomainRequest: SetIdDomainRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDomainId(setIdDomainRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeCardSyncResponseDto> {
            return localVarFp.syncCard(customerId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} mandateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDirectDebitMandatesV4200ResponseInner> {
            return localVarFp.syncDirectDebitMandateV4(customerId, mandateId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} id 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFile(customerId: string, id: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<FilexDto> {
            return localVarFp.syncFile(customerId, id, uploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncPortfolio(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Get a list of transaction conditions from Enfuce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionConditions(options?: RawAxiosRequestConfig): AxiosPromise<Array<BackOfficeTransactionConditionDto>> {
            return localVarFp.transactionConditions(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @summary Trigger expense checker outcome migration
         * @param {boolean} [realRun] 
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trigger(realRun?: boolean, limit?: number, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<ExpenseCheckerMigrationResult> {
            return localVarFp.trigger(realRun, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerBusinessEvent(customerId: string, txId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResourceResponse> {
            return localVarFp.triggerBusinessEvent(customerId, txId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} customerId 
         * @param {string} txId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerBusinessEventV2(customerId: string, txId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResourceResponse> {
            return localVarFp.triggerBusinessEventV2(customerId, txId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BureauUnassingmentRequest} bureauUnassingmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassign(bureauUnassingmentRequest: BureauUnassingmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<BureauUnassingmentResponse> {
            return localVarFp.unassign(bureauUnassingmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unauthorizedException(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.unauthorizedException(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} alarmId 
         * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolveAlarm(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unresolveAlarm(alarmId, resolveAlarmRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {AccountDto} accountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount(id: string, accountDto: AccountDto, options?: RawAxiosRequestConfig): AxiosPromise<AccountDto> {
            return localVarFp.updateAccount(id, accountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonMailDto} updateAuthPersonMailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthPersonMail(updateAuthPersonMailDto: UpdateAuthPersonMailDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAuthPersonMail(updateAuthPersonMailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {UpdateAuthPersonPhoneDto} updateAuthPersonPhoneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthPersonPhoneNumber(updateAuthPersonPhoneDto: UpdateAuthPersonPhoneDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAuthPersonPhoneNumber(updateAuthPersonPhoneDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRoleOrSalesRoleAndAllowed(#patch.onlyInvite())
         * @param {string} id 
         * @param {string} personId 
         * @param {PersonPatchDto} personPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerson(id: string, personId: string, personPatchDto: PersonPatchDto, options?: RawAxiosRequestConfig): AxiosPromise<PersonDto> {
            return localVarFp.updatePerson(id, personId, personPatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} countryCode 
         * @param {string} ruleCode 
         * @param {UpdateRuleRequest} updateRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleWithParameters(portfolioId: string, countryCode: string, ruleCode: string, updateRuleRequest: UpdateRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRuleWithParameters(portfolioId, countryCode, ruleCode, updateRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {TextProcessorPatternPatchDto} textProcessorPatternPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTextProcessorConfiguration(id: string, textProcessorPatternPatchDto: TextProcessorPatternPatchDto, options?: RawAxiosRequestConfig): AxiosPromise<TextProcessorPatternDto> {
            return localVarFp.updateTextProcessorConfiguration(id, textProcessorPatternPatchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {AccountXYear} accountXYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYear(id: string, accountXYear: AccountXYear, options?: RawAxiosRequestConfig): AxiosPromise<AccountXYear> {
            return localVarFp.updateYear(id, accountXYear, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<MonitoringPortfolioCreditSafeMapping>} monitoringPortfolioCreditSafeMapping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCreditsafeIdMappings(monitoringPortfolioCreditSafeMapping: Array<MonitoringPortfolioCreditSafeMapping>, options?: RawAxiosRequestConfig): AxiosPromise<MonitoringPortfolioUploadResponse> {
            return localVarFp.uploadCreditsafeIdMappings(monitoringPortfolioCreditSafeMapping, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whiteListPaymentV1(paymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.whiteListPaymentV1(paymentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BackOfficeAPIApi - object-oriented interface
 * @export
 * @class BackOfficeAPIApi
 * @extends {BaseAPI}
 */
export class BackOfficeAPIApi extends BaseAPI {
    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public _delete(id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public accountsBasic(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).accountsBasic(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {string} plasticId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public activatePlastic(customerId: string, cardId: string, plasticId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).activatePlastic(customerId, cardId, plasticId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} countryCode 
     * @param {string} ruleCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public activateRule(portfolioId: string, countryCode: string, ruleCode: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).activateRule(portfolioId, countryCode, ruleCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public add(body: any, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).add(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public add1(customerId: string, body: any, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).add1(customerId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} country 
     * @param {string} regNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public addCompanyToPortfolio(portfolioId: string, country: string, regNo: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).addCompanyToPortfolio(portfolioId, country, regNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {UploadRequest} uploadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public addFile(customerId: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).addFile(customerId, uploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} itemId 
     * @param {SnoozeDto} snoozeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public addSnooze(itemId: string, snoozeDto: SnoozeDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).addSnooze(itemId, snoozeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} validFrom 
     * @param {number} foodAndBeverageDeductionLimit 
     * @param {number} simpleFoodDeductionLimit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public addSwedishRepresentationVATValues(validFrom: string, foodAndBeverageDeductionLimit: number, simpleFoodDeductionLimit: number, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).addSwedishRepresentationVATValues(validFrom, foodAndBeverageDeductionLimit, simpleFoodDeductionLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public alreadyExistingException(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).alreadyExistingException(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {BureauRelationshipRequest} bureauRelationshipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public assign(bureauRelationshipRequest: BureauRelationshipRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).assign(bureauRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public backofficeRoleChecker(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).backofficeRoleChecker(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PersonLoginRequest} personLoginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public bizOpsLogin(personLoginRequest: PersonLoginRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).bizOpsLogin(personLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} bureauId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public bureau(bureauId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).bureau(bureauId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} bureauId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public bureauClients(bureauId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).bureauClients(bureauId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} bureauId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public bureauPendingTasks(bureauId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).bureauPendingTasks(bureauId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} mandateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public cancelDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).cancelDirectDebitMandateV4(customerId, mandateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} depositId 
     * @param {string} userAgent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public cancelPisDeposit(customerId: string, depositId: string, userAgent: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).cancelPisDeposit(customerId, depositId, userAgent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public cardDeliveryAddress(customerId: string, personId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).cardDeliveryAddress(customerId, personId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public cards(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).cards(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary churn customer
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public churnCustomer(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).churnCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public client(clientId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).client(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {BureauConfigRequest} bureauConfigRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public configure(bureauConfigRequest: BureauConfigRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).configure(bureauConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} [search] 
     * @param {string} [customerId] 
     * @param {Array<string>} [country] 
     * @param {Array<string>} [partner] 
     * @param {Array<string>} [kycStatus] 
     * @param {Array<RequestStatus>} [requestStatus] 
     * @param {Array<PendingReason>} [pendingReason] 
     * @param {boolean} [hasPendingReasons] 
     * @param {Array<AgreementStatus>} [agreementStatus] 
     * @param {boolean} [snoozed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public countCreditApplications(search?: string, customerId?: string, country?: Array<string>, partner?: Array<string>, kycStatus?: Array<string>, requestStatus?: Array<RequestStatus>, pendingReason?: Array<PendingReason>, hasPendingReasons?: boolean, agreementStatus?: Array<AgreementStatus>, snoozed?: boolean, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).countCreditApplications(search, customerId, country, partner, kycStatus, requestStatus, pendingReason, hasPendingReasons, agreementStatus, snoozed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {AccountDto} accountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createAccount(accountDto: AccountDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createAccount(accountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary Create a new Agreement with status draft
     * @param {string} customerId 
     * @param {BackOfficeAgreementCreationDtoV8} backOfficeAgreementCreationDtoV8 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createAgreementV8(customerId: string, backOfficeAgreementCreationDtoV8: BackOfficeAgreementCreationDtoV8, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createAgreementV8(customerId, backOfficeAgreementCreationDtoV8, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {CreateAuthPersonForEmailDto} createAuthPersonForEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createAuthPersonForEmail(createAuthPersonForEmailDto: CreateAuthPersonForEmailDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createAuthPersonForEmail(createAuthPersonForEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary create a new customer entity
     * @param {BackOfficeCustomerCreateDtoV2} backOfficeCustomerCreateDtoV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createCustomer(backOfficeCustomerCreateDtoV2: BackOfficeCustomerCreateDtoV2, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createCustomer(backOfficeCustomerCreateDtoV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {CreateDirectDebitMandateV4Request} createDirectDebitMandateV4Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createDirectDebitMandateV4(customerId: string, createDirectDebitMandateV4Request: CreateDirectDebitMandateV4Request, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createDirectDebitMandateV4(customerId, createDirectDebitMandateV4Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {CreatePasswordRequestDto} createPasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createPasswords(createPasswordRequestDto: CreatePasswordRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createPasswords(createPasswordRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {BackOfficeCreatePaymentForCustomerRequestDto} backOfficeCreatePaymentForCustomerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createPayment(backOfficeCreatePaymentForCustomerRequestDto: BackOfficeCreatePaymentForCustomerRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createPayment(backOfficeCreatePaymentForCustomerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {CreatePersonDto} createPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createPersonWithRoles(id: string, createPersonDto: CreatePersonDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createPersonWithRoles(id, createPersonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePortfolioRequest} createPortfolioRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createPortfolio(createPortfolioRequest: CreatePortfolioRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createPortfolio(createPortfolioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary Create new signatories data
     * @param {string} customerId 
     * @param {Array<BackOfficeSignatoryDto>} backOfficeSignatoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createSignatories(customerId: string, backOfficeSignatoryDto: Array<BackOfficeSignatoryDto>, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createSignatories(customerId, backOfficeSignatoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {CreatePaymentRequestDtoV2} createPaymentRequestDtoV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createV2(createPaymentRequestDtoV2: CreatePaymentRequestDtoV2, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createV2(createPaymentRequestDtoV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {VoucherDto} voucherDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createVoucher(voucherDto: VoucherDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createVoucher(voucherDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {AccountXYear} accountXYear 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public createYear(accountXYear: AccountXYear, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).createYear(accountXYear, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} countryCode 
     * @param {string} ruleCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deactivateRule(portfolioId: string, countryCode: string, ruleCode: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deactivateRule(portfolioId, countryCode, ruleCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public delete1(customerId: string, id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).delete1(customerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteAccount(id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteAccount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {PersonsToDeleteAuthPersonIds} personsToDeleteAuthPersonIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteAuthPerson(personsToDeleteAuthPersonIds: PersonsToDeleteAuthPersonIds, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteAuthPerson(personsToDeleteAuthPersonIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteCustomer(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} authpersonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteExistingAuthPerson(authpersonId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteExistingAuthPerson(authpersonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {BillingSettingsFeatureName} featureName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteFeatureOverride(customerId: string, featureName: BillingSettingsFeatureName, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteFeatureOverride(customerId, featureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteFile(customerId: string, id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteFile(customerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {BillingSettingsFieldName} fieldName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteOverrides(customerId: string, fieldName: BillingSettingsFieldName, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteOverrides(customerId, fieldName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} paymentWhiteListId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deletePaymentWhiteListV1(customerId: string, paymentWhiteListId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deletePaymentWhiteListV1(customerId, paymentWhiteListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deletePerson(id: string, personId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deletePerson(id, personId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deletePreorderCardV1(customerId: string, cardId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deletePreorderCardV1(customerId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteSnooze(itemId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteSnooze(itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteTextProcessorConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteTextProcessorConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public deleteYear(id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).deleteYear(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public directLoginToken(id: string, personId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).directLoginToken(id, personId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FetchRequestDto} fetchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public fetch(fetchRequestDto: FetchRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).fetch(fetchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public fetchAndSaveNotifications(fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).fetchAndSaveNotifications(fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public findAll(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public findBy(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).findBy(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary List audit logs
     * @param {string} [customerId] 
     * @param {string} [resourceId] 
     * @param {Array<string>} [hierarchyElement] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public findByCustomerId(customerId?: string, resourceId?: string, hierarchyElement?: Array<string>, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).findByCustomerId(customerId, resourceId, hierarchyElement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @summary fetch a customer entity by id
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public findCustomerById(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).findCustomerById(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public findEInvoiceAddresses(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).findEInvoiceAddresses(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public forbiddenException(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).forbiddenException(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public generalException(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).generalException(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public get(id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public get1(customerId: string, id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).get1(customerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAccount(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAccount(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAccount3(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAccount3(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @summary Get an accounts balance, available, and creditlimit. This requires a downstream call to enfuce.
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAccountStatusV5(customerId: string, accountId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAccountStatusV5(customerId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAccountV2(customerId: string, accountId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAccountV2(customerId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @summary Get an account on customer
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAccountV5(customerId: string, accountId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAccountV5(customerId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAccounts(year?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAccounts(year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAccountsV2(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAccountsV2(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @summary Get a list of all accounts on customer
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAccountsV5(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAccountsV5(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getActivationGuide(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getActivationGuide(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getActivationGuideVisibility(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getActivationGuideVisibility(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getActiveAlarms(pageNumber?: number, pageSize?: number, sortDirection?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getActiveAlarms(pageNumber, pageSize, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageSize] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getActiveSessions(pageSize?: number, pageNumber?: number, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getActiveSessions(pageSize, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary Get agreement details for given agreement-id
     * @param {string} customerId 
     * @param {string} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAgreementV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAgreementV8(customerId, agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} alarmId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAlarmById(alarmId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAlarmById(alarmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAlarmsByCustomerId(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAlarmsByCustomerId(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @summary Get a list of all agreements on customer
     * @param {string} customerId 
     * @param {Array<BackOfficeAgreementTypeV8>} [agreementType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAllAgreementsV8(customerId: string, agreementType?: Array<BackOfficeAgreementTypeV8>, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAllAgreementsV8(customerId, agreementType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {string} [status] 
     * @param {string} [companyName] 
     * @param {string} [sortDirection] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAllAlarms(pageNumber?: number, pageSize?: number, status?: string, companyName?: string, sortDirection?: string, search?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAllAlarms(pageNumber, pageSize, status, companyName, sortDirection, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAllContexts(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAllContexts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAllEventRules(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAllEventRules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAllMonthlyReports(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAllMonthlyReports(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAllNotificationEvents(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAllNotificationEvents(fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAllTextProcessorConfigurations(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAllTextProcessorConfigurations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {Array<string>} [years] 
     * @param {Array<number>} [accounts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAllVouchers(from?: string, to?: string, years?: Array<string>, accounts?: Array<number>, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAllVouchers(from, to, years, accounts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authpersonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getAuthPersonInfo(authpersonId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getAuthPersonInfo(authpersonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @summary Offset, start transaction list at this offset. Limit is how many transactions to return. transactionDate do not have a timezone
     * @param {string} customerId 
     * @param {number} [offset] pagination offset
     * @param {number} [limit] pagination limit
     * @param {string} [from] from date (inclusive) in ISO format, yyyy-MM-dd
     * @param {string} [to] to date (inclusive) in ISO format, yyyy-MM-dd
     * @param {number} [min] min transaction amount (inclusive)
     * @param {number} [max] max transaction amount (inclusive)
     * @param {Array<TransactionFilters>} [onlyinclude] various transaction property filters, some are mutually exclusive
     * @param {Array<TransactionFilters>} [exclude] 
     * @param {Array<AttestStatus>} [attestStatus] 
     * @param {string} [query] Free text query search. At least 3 characters, otherwise ignored
     * @param {Array<string>} [personIds] \&#39;or-ed\&#39; person id\&#39;s to query for, if omitted then transactions for all users will be returned. note: returned set increases with with more personIds and decreases with less personId, except for the empty set which returns all transactions
     * @param {Array<string>} [cardIds] 
     * @param {Array<BackOfficeTx2StatusFilter2>} [status] Filter on transaction status. Leave empty to include all statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getBoTransactionsV2(customerId: string, offset?: number, limit?: number, from?: string, to?: string, min?: number, max?: number, onlyinclude?: Array<TransactionFilters>, exclude?: Array<TransactionFilters>, attestStatus?: Array<AttestStatus>, query?: string, personIds?: Array<string>, cardIds?: Array<string>, status?: Array<BackOfficeTx2StatusFilter2>, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getBoTransactionsV2(customerId, offset, limit, from, to, min, max, onlyinclude, exclude, attestStatus, query, personIds, cardIds, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getByCustomerId(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getByCustomerId(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCard(customerId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCardBalanceConfig(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCardBalanceConfig(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCardConfig(customerId: string, cardId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCardConfig(customerId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {string} creditId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCardCreditV2(customerId: string, creditId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCardCreditV2(customerId, creditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCardCreditsV2(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCardCreditsV2(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCardPlastics(customerId: string, cardId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCardPlastics(customerId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCardV1(customerId: string, cardId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCardV1(customerId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCards(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCards(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCorporateCustomer(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCorporateCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getCreditApplication(requestId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getCreditApplication(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getDirectDebitMandatesV4(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getDirectDebitMandatesV4(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getEventRulesByCountry(countryCode: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getEventRulesByCountry(countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getEventRulesForPortfolio(portfolioId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getEventRulesForPortfolio(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getEventRulesForPortfolioAndCountry(portfolioId: string, countryCode: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getEventRulesForPortfolioAndCountry(portfolioId, countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {Array<string>} [contexts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getFiles(customerId: string, contexts?: Array<string>, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getFiles(customerId, contexts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getGermanyDistrictCourtCodes(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getGermanyDistrictCourtCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {Array<InboxItemType>} [types] Filter for specific types. Accepts a comma separated list. If omitted, all types are returned
     * @param {boolean} [snoozed] should snoozed items be included or not
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getInbox(types?: Array<InboxItemType>, snoozed?: boolean, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getInbox(types, snoozed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getInvoicingConfigV1(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getInvoicingConfigV1(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getLatestSession(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getLatestSession(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPartners(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPartners(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPayment(paymentId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPayment(paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPaymentDeclaration(submissionId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPaymentDeclaration(submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPaymentReceiverV1(paymentId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPaymentReceiverV1(paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} paymentRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPaymentRequestV2(paymentRequestId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPaymentRequestV2(paymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} [customerId] 
     * @param {string} [cardCreditId] 
     * @param {Array<string>} [currency] 
     * @param {boolean} [hasPaidEnough] 
     * @param {Array<PaymentRequestStatusDtoV2>} [status] 
     * @param {string} [dueDateFrom] 
     * @param {string} [dueDateTo] 
     * @param {string} [paymentRequestDateFrom] 
     * @param {string} [paymentRequestDateTo] 
     * @param {string} [periodFrom] 
     * @param {string} [periodTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPaymentRequestsV2(customerId?: string, cardCreditId?: string, currency?: Array<string>, hasPaidEnough?: boolean, status?: Array<PaymentRequestStatusDtoV2>, dueDateFrom?: string, dueDateTo?: string, paymentRequestDateFrom?: string, paymentRequestDateTo?: string, periodFrom?: string, periodTo?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPaymentRequestsV2(customerId, cardCreditId, currency, hasPaidEnough, status, dueDateFrom, dueDateTo, paymentRequestDateFrom, paymentRequestDateTo, periodFrom, periodTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPaymentWhiteListV1(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPaymentWhiteListV1(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {Array<PaymentState>} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPayments(state?: Array<PaymentState>, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPayments(state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPayoutRequest(id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPayoutRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} paymentRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPdfV2(paymentRequestId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPdfV2(paymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPersonsWithRoles(id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPersonsWithRoles(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPreSignedUrl(customerId: string, id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPreSignedUrl(customerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPreferredDirectDebitMandateV4(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPreferredDirectDebitMandateV4(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getPrivateCustomers(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getPrivateCustomers(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getRawAccountV3(customerId: string, accountId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getRawAccountV3(customerId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getRawAccountV4(customerId: string, accountId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getRawAccountV4(customerId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getRawAccountsV3(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getRawAccountsV3(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getRawAccountsV4(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getRawAccountsV4(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orgNo 
     * @param {string} country 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getSavedNotifications(orgNo: string, country: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getSavedNotifications(orgNo, country, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @summary Get signatories data
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getSignatories(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getSignatories(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} txId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getTransaction(customerId: string, txId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getTransaction(customerId, txId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @summary offset takes precedence over page if provided. Page is still available for backward compatibility. limit defaults to 20
     * @param {string} customerId 
     * @param {number} [page] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getTransactionsCombined(customerId: string, page?: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getTransactionsCombined(customerId, page, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getUpgradeOption(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getUpgradeOption(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {Array<string>} [years] 
     * @param {Array<number>} [accounts] 
     * @param {string} [currency] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getVouchersResultReport(from?: string, to?: string, years?: Array<string>, accounts?: Array<number>, currency?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getVouchersResultReport(from, to, years, accounts, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public getYears(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).getYears(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} callback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public googleOAuthRedir(callback: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).googleOAuthRedir(callback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public illegalArgumentException(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).illegalArgumentException(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public illegalStateException(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).illegalStateException(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} depositId 
     * @param {string} userAgent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public inspectPisDeposit(customerId: string, depositId: string, userAgent: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).inspectPisDeposit(customerId, depositId, userAgent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public isLoggedIn(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).isLoggedIn(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public kycApproved(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).kycApproved(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {BackOfficeCustomerKycRequiresRenewalDtoV2} backOfficeCustomerKycRequiresRenewalDtoV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public kycRequiresRenewal(customerId: string, backOfficeCustomerKycRequiresRenewalDtoV2: BackOfficeCustomerKycRequiresRenewalDtoV2, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).kycRequiresRenewal(customerId, backOfficeCustomerKycRequiresRenewalDtoV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public list(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).list(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} [searchQuery] 
     * @param {number} [pageSize] 
     * @param {number} [page] 
     * @param {string} [countryCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public listCompaniesInPortfolio(portfolioId: string, searchQuery?: string, pageSize?: number, page?: number, countryCode?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).listCompaniesInPortfolio(portfolioId, searchQuery, pageSize, page, countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} depositId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public listPisDepositEvents(customerId: string, depositId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).listPisDepositEvents(customerId, depositId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public listPisDeposits(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).listPisDeposits(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public listPortfolios(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).listPortfolios(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public log(id: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).log(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} alarmId 
     * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public markAlarmUnderReview(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).markAlarmUnderReview(alarmId, resolveAlarmRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {RequestDto} requestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public migrateAuth0Users(requestDto: RequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).migrateAuth0Users(requestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public notFoundException(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).notFoundException(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} creditId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public notifyCardCreditDenied(customerId: string, creditId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).notifyCardCreditDenied(customerId, creditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} creditId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public notifyCardCreditRaiseDenied(customerId: string, creditId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).notifyCardCreditRaiseDenied(customerId, creditId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {BackOfficeOrderCardRequestDtoV3} backOfficeOrderCardRequestDtoV3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public orderCardV3(customerId: string, backOfficeOrderCardRequestDtoV3: BackOfficeOrderCardRequestDtoV3, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).orderCardV3(customerId, backOfficeOrderCardRequestDtoV3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {PatchPrepaidResourceBody} patchPrepaidResourceBody 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchAccount(customerId: string, patchPrepaidResourceBody: PatchPrepaidResourceBody, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchAccount(customerId, patchPrepaidResourceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {BackOfficeAccountPatchDto} backOfficeAccountPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchAccountV2(customerId: string, accountId: string, backOfficeAccountPatchDto: BackOfficeAccountPatchDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchAccountV2(customerId, accountId, backOfficeAccountPatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {ActivationGuidePatchDto} activationGuidePatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchActivationGuideVisibility(customerId: string, activationGuidePatchDto: ActivationGuidePatchDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchActivationGuideVisibility(customerId, activationGuidePatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {ActivationGuidePatchDto} activationGuidePatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchActivationGuideVisibility1(customerId: string, activationGuidePatchDto: ActivationGuidePatchDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchActivationGuideVisibility1(customerId, activationGuidePatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {PatchStandardResourceBody} patchStandardResourceBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchCard(customerId: string, cardId: string, patchStandardResourceBody: PatchStandardResourceBody, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchCard(customerId, cardId, patchStandardResourceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {CardBalanceConfigPatchDto} cardBalanceConfigPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchCardBalanceConfig(customerId: string, cardBalanceConfigPatchDto: CardBalanceConfigPatchDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchCardBalanceConfig(customerId, cardBalanceConfigPatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {CardConfigPatchRequestDto} cardConfigPatchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchCardConfig(customerId: string, cardId: string, cardConfigPatchRequestDto: CardConfigPatchRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchCardConfig(customerId, cardId, cardConfigPatchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} creditId 
     * @param {BackOfficeCardCreditPatchV2Dto} backOfficeCardCreditPatchV2Dto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchCardCreditV2(customerId: string, creditId: string, backOfficeCardCreditPatchV2Dto: BackOfficeCardCreditPatchV2Dto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchCardCreditV2(customerId, creditId, backOfficeCardCreditPatchV2Dto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {BackOfficeCardPatchDto} backOfficeCardPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchCardV1(customerId: string, cardId: string, backOfficeCardPatchDto: BackOfficeCardPatchDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchCardV1(customerId, cardId, backOfficeCardPatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRoleOrSalesRoleAndAllowed(#patch.changesOnlyProducts() || #patch.changesOnlyChannel())
     * @param {string} customerId 
     * @param {BackOfficeCustomerPatchDtoV2} backOfficeCustomerPatchDtoV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchCustomer(customerId: string, backOfficeCustomerPatchDtoV2: BackOfficeCustomerPatchDtoV2, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchCustomer(customerId, backOfficeCustomerPatchDtoV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {BillingSettingsFeatureOverridePatch} billingSettingsFeatureOverridePatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchFeatureOverrides(customerId: string, billingSettingsFeatureOverridePatch: BillingSettingsFeatureOverridePatch, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchFeatureOverrides(customerId, billingSettingsFeatureOverridePatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {BackofficeInvoicingConfigPatchDto} backofficeInvoicingConfigPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchInvoicingConfigV1(customerId: string, backofficeInvoicingConfigPatchDto: BackofficeInvoicingConfigPatchDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchInvoicingConfigV1(customerId, backofficeInvoicingConfigPatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {BillingSettingsOverridePatch} billingSettingsOverridePatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchOverrides(customerId: string, billingSettingsOverridePatch: BillingSettingsOverridePatch, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchOverrides(customerId, billingSettingsOverridePatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} paymentId 
     * @param {BackOfficePatchPaymentRequestDto} backOfficePatchPaymentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchPayment(paymentId: string, backOfficePatchPaymentRequestDto: BackOfficePatchPaymentRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchPayment(paymentId, backOfficePatchPaymentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} paymentRequestId 
     * @param {PatchPaymentRequestDtoV2} patchPaymentRequestDtoV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchPaymentRequestV2(paymentRequestId: string, patchPaymentRequestDtoV2: PatchPaymentRequestDtoV2, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchPaymentRequestV2(paymentRequestId, patchPaymentRequestDtoV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {PatchV3ResourceBody} patchV3ResourceBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchRawAccountV3(customerId: string, accountId: string, patchV3ResourceBody: PatchV3ResourceBody, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchRawAccountV3(customerId, accountId, patchV3ResourceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {PatchPrepaidResourceBody} patchPrepaidResourceBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchRawAccountV4(customerId: string, accountId: string, patchPrepaidResourceBody: PatchPrepaidResourceBody, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchRawAccountV4(customerId, accountId, patchPrepaidResourceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {BillingSettingsTrialOverridePatch} billingSettingsTrialOverridePatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public patchTrialOverrides(customerId: string, billingSettingsTrialOverridePatch: BillingSettingsTrialOverridePatch, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).patchTrialOverrides(customerId, billingSettingsTrialOverridePatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} id 
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public person(id: string, personId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).person(id, personId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} paymentRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public postRecalculateV2(paymentRequestId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).postRecalculateV2(paymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public put(id: string, body: any, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).put(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} id 
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public put1(customerId: string, id: string, body: any, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).put1(customerId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole() Idempotent write of a projected credit application row. Rows with a projectedAt older than or equal to the stored row are ignored.
     * @param {string} requestId 
     * @param {BackofficeCreditApplicationV1Dto} backofficeCreditApplicationV1Dto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public putCreditApplication(requestId: string, backofficeCreditApplicationV1Dto: BackofficeCreditApplicationV1Dto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).putCreditApplication(requestId, backofficeCreditApplicationV1Dto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} submissionId 
     * @param {BackOfficePaymentDeclarationDecisionRequestV1Dto} backOfficePaymentDeclarationDecisionRequestV1Dto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public recordDecision(submissionId: string, backOfficePaymentDeclarationDecisionRequestV1Dto: BackOfficePaymentDeclarationDecisionRequestV1Dto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).recordDecision(submissionId, backOfficePaymentDeclarationDecisionRequestV1Dto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public refreshAddress(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).refreshAddress(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public reissueCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).reissueCard(customerId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {DeleteAuthPersonDto} deleteAuthPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public removeAuthPerson(deleteAuthPersonDto: DeleteAuthPersonDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).removeAuthPerson(deleteAuthPersonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} country 
     * @param {string} regNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public removeCompanyFromPortfolio(portfolioId: string, country: string, regNo: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).removeCompanyFromPortfolio(portfolioId, country, regNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {DeleteAuthPersonDto} deleteAuthPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public removeEmailAuthPerson(deleteAuthPersonDto: DeleteAuthPersonDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).removeEmailAuthPerson(deleteAuthPersonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} mandateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public resendDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).resendDirectDebitMandateV4(customerId, mandateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {ResetRequest} resetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public resetBureau(resetRequest: ResetRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).resetBureau(resetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public resetPinAttempt(customerId: string, cardId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).resetPinAttempt(customerId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public resetRulesToDefault(portfolioId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).resetRulesToDefault(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} alarmId 
     * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public resolveAlarm(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).resolveAlarm(alarmId, resolveAlarmRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} amlCheckId 
     * @param {AmlCheckResolutionRequest} amlCheckResolutionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public resolveAmlCheck(amlCheckId: string, amlCheckResolutionRequest: AmlCheckResolutionRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).resolveAmlCheck(amlCheckId, amlCheckResolutionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasRole(\'BACKOFFICE_SALES\')
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public salesRoleChecker(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).salesRoleChecker(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} q 
     * @param {number} [n] 
     * @param {string} [t] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public search(q: string, n?: number, t?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).search(q, n, t, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} [search] 
     * @param {string} [customerId] 
     * @param {Array<string>} [country] 
     * @param {Array<string>} [partner] 
     * @param {Array<string>} [kycStatus] 
     * @param {Array<RequestStatus>} [requestStatus] 
     * @param {Array<PendingReason>} [pendingReason] 
     * @param {boolean} [hasPendingReasons] 
     * @param {Array<AgreementStatus>} [agreementStatus] 
     * @param {boolean} [snoozed] 
     * @param {Field} [sortBy] 
     * @param {Direction} [sortDirection] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public searchCreditApplications(search?: string, customerId?: string, country?: Array<string>, partner?: Array<string>, kycStatus?: Array<string>, requestStatus?: Array<RequestStatus>, pendingReason?: Array<PendingReason>, hasPendingReasons?: boolean, agreementStatus?: Array<AgreementStatus>, snoozed?: boolean, sortBy?: Field, sortDirection?: Direction, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).searchCreditApplications(search, customerId, country, partner, kycStatus, requestStatus, pendingReason, hasPendingReasons, agreementStatus, snoozed, sortBy, sortDirection, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public searchTypes(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).searchTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddBankDataRequestDto} addBankDataRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendAddBankDataEmail(addBankDataRequestDto: AddBankDataRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendAddBankDataEmail(addBankDataRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary Email agreement to all signatories
     * @param {string} customerId 
     * @param {string} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendAgreementEmailV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendAgreementEmailV8(customerId, agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary Send reminder email for unsigned credit agreement
     * @param {string} customerId 
     * @param {string} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendAgreementReminderV8(customerId: string, agreementId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendAgreementReminderV8(customerId, agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendKycExpiredEmail(customerId: string, body: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendKycExpiredEmail(customerId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} body 
     * @param {boolean} [ssnWaiver] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendKycLinkEmail(customerId: string, body: string, ssnWaiver?: boolean, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendKycLinkEmail(customerId, body, ssnWaiver, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendKycRenewalEmail(customerId: string, body: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendKycRenewalEmail(customerId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {MonthlyReportRequest} monthlyReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendMonthlyReport(customerId: string, monthlyReportRequest: MonthlyReportRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendMonthlyReport(customerId, monthlyReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NewBankDataSessionRequestDto} newBankDataSessionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendNewBankDataSessionEmail(newBankDataSessionRequestDto: NewBankDataSessionRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendNewBankDataSessionEmail(newBankDataSessionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} cid 
     * @param {string} pid 
     * @param {SmsRequestDto} smsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendSms(cid: string, pid: string, smsRequestDto: SmsRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendSms(cid, pid, smsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} cid 
     * @param {string} phoneNumber 
     * @param {SmsRequestDto} smsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendSmsToPhoneNumber(cid: string, phoneNumber: string, smsRequestDto: SmsRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendSmsToPhoneNumber(cid, phoneNumber, smsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {Request} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendTestKycReminderSms(request: Request, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendTestKycReminderSms(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullOrSalesRole()
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public sendWelcomeEmail(customerId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).sendWelcomeEmail(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {UpdateAuthPersonDto} updateAuthPersonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public setAuthPersonId(updateAuthPersonDto: UpdateAuthPersonDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).setAuthPersonId(updateAuthPersonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetIdDomainRequest} setIdDomainRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public setDomainId(setIdDomainRequest: SetIdDomainRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).setDomainId(setIdDomainRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public syncCard(customerId: string, cardId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).syncCard(customerId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} mandateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public syncDirectDebitMandateV4(customerId: string, mandateId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).syncDirectDebitMandateV4(customerId, mandateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} id 
     * @param {UploadRequest} uploadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public syncFile(customerId: string, id: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).syncFile(customerId, id, uploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public syncPortfolio(portfolioId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).syncPortfolio(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary Get a list of transaction conditions from Enfuce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public transactionConditions(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).transactionConditions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @summary Trigger expense checker outcome migration
     * @param {boolean} [realRun] 
     * @param {number} [limit] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public trigger(realRun?: boolean, limit?: number, cursor?: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).trigger(realRun, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} txId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public triggerBusinessEvent(customerId: string, txId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).triggerBusinessEvent(customerId, txId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} customerId 
     * @param {string} txId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public triggerBusinessEventV2(customerId: string, txId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).triggerBusinessEventV2(customerId, txId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {BureauUnassingmentRequest} bureauUnassingmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public unassign(bureauUnassingmentRequest: BureauUnassingmentRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).unassign(bureauUnassingmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public unauthorizedException(options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).unauthorizedException(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} alarmId 
     * @param {ResolveAlarmRequestDto} resolveAlarmRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public unresolveAlarm(alarmId: string, resolveAlarmRequestDto: ResolveAlarmRequestDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).unresolveAlarm(alarmId, resolveAlarmRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {AccountDto} accountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public updateAccount(id: string, accountDto: AccountDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).updateAccount(id, accountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {UpdateAuthPersonMailDto} updateAuthPersonMailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public updateAuthPersonMail(updateAuthPersonMailDto: UpdateAuthPersonMailDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).updateAuthPersonMail(updateAuthPersonMailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {UpdateAuthPersonPhoneDto} updateAuthPersonPhoneDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public updateAuthPersonPhoneNumber(updateAuthPersonPhoneDto: UpdateAuthPersonPhoneDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).updateAuthPersonPhoneNumber(updateAuthPersonPhoneDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRoleOrSalesRoleAndAllowed(#patch.onlyInvite())
     * @param {string} id 
     * @param {string} personId 
     * @param {PersonPatchDto} personPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public updatePerson(id: string, personId: string, personPatchDto: PersonPatchDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).updatePerson(id, personId, personPatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} countryCode 
     * @param {string} ruleCode 
     * @param {UpdateRuleRequest} updateRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public updateRuleWithParameters(portfolioId: string, countryCode: string, ruleCode: string, updateRuleRequest: UpdateRuleRequest, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).updateRuleWithParameters(portfolioId, countryCode, ruleCode, updateRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {TextProcessorPatternPatchDto} textProcessorPatternPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public updateTextProcessorConfiguration(id: string, textProcessorPatternPatchDto: TextProcessorPatternPatchDto, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).updateTextProcessorConfiguration(id, textProcessorPatternPatchDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {AccountXYear} accountXYear 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public updateYear(id: string, accountXYear: AccountXYear, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).updateYear(id, accountXYear, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<MonitoringPortfolioCreditSafeMapping>} monitoringPortfolioCreditSafeMapping 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public uploadCreditsafeIdMappings(monitoringPortfolioCreditSafeMapping: Array<MonitoringPortfolioCreditSafeMapping>, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).uploadCreditsafeIdMappings(monitoringPortfolioCreditSafeMapping, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackOfficeAPIApi
     */
    public whiteListPaymentV1(paymentId: string, options?: RawAxiosRequestConfig) {
        return BackOfficeAPIApiFp(this.configuration).whiteListPaymentV1(paymentId, options).then((request) => request(this.axios, this.basePath));
    }
}

